export function ChangReqIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
    >
      <path
        d="M4.42061 16.4295C4.7473 16.5068 5.08257 16.567 5.40926 16.6702C7.02547 17.2032 8.12587 18.6732 8.18605 20.3668C8.19465 20.6935 8.20324 21.0288 8.18605 21.3555C8.16886 21.7509 7.93674 21.9916 7.53269 22.0002C5.24592 22.0088 2.95914 22.0088 0.672373 22.0002C0.311304 22.0002 0.0533978 21.7939 0.0276072 21.4414C-0.11854 19.7307 0.294111 18.2348 1.78137 17.186C2.34877 16.7819 2.97634 16.5326 3.68128 16.4896C3.9134 16.3091 4.16271 16.3435 4.42061 16.4295Z"
        fill="#FB6B6B"
      />
      <path
        d="M4.42042 16.428C4.17971 16.5483 3.9218 16.4366 3.68109 16.4968C3.58653 16.3678 3.43178 16.3764 3.30283 16.342C1.85855 15.9294 0.887105 14.5109 1.07624 13.0924C1.29116 11.4934 2.5463 10.3758 4.10234 10.3672C5.62399 10.3672 6.91352 11.4848 7.12844 12.9892C7.34336 14.4851 6.38911 15.9208 4.91904 16.3334C4.7557 16.3764 4.60096 16.4624 4.42042 16.428Z"
        fill="#FB6B6B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.28809 3.00891V8.85479V14.9156C8.28809 15.2509 8.32247 15.5604 8.65775 15.7237C8.99303 15.8956 9.25953 15.7237 9.51744 15.526C9.82381 15.2915 10.1319 15.0603 10.4394 14.8295L10.4394 14.8295C10.8308 14.5357 11.2213 14.2426 11.6065 13.9441C11.8128 13.7808 12.0191 13.7206 12.277 13.7206C14.5466 13.7292 16.8248 13.7292 19.103 13.7206C20.8653 13.712 22.0001 12.5772 22.0001 10.8149V2.91434C22.0001 1.12619 20.8653 0 19.0686 0H11.297C9.39708 0 8.28809 1.1004 8.28809 3.00891ZM11.8635 4.74434H15.1217H18.4229C18.9473 4.74434 19.2482 4.49503 19.2396 4.09097C19.231 3.70411 18.9301 3.4634 18.4315 3.4634H11.8721C11.3476 3.4634 11.0554 3.71271 11.064 4.12536C11.0725 4.52942 11.3391 4.74434 11.8635 4.74434ZM15.1217 7.49873H11.8635C11.3391 7.49873 11.0725 7.28381 11.064 6.87976C11.0554 6.45851 11.3476 6.2178 11.8807 6.2178H18.4401C18.9387 6.2178 19.2396 6.45851 19.2482 6.85396C19.2568 7.25802 18.9559 7.50733 18.4229 7.50733C17.8727 7.50733 17.3225 7.50518 16.7723 7.50303C16.2221 7.50088 15.6719 7.49873 15.1217 7.49873ZM12.655 10.2679C12.8069 10.267 12.9588 10.266 13.1106 10.266C13.3331 10.266 13.5534 10.2681 13.7748 10.2703C13.9983 10.2724 14.2228 10.2746 14.4517 10.2746C14.8988 10.2574 15.1481 10.0167 15.1481 9.62985C15.1395 9.26018 14.9074 9.00228 14.4861 8.99368C13.5749 8.97649 12.655 8.97649 11.7437 8.99368C11.3053 8.99368 11.0474 9.26878 11.0646 9.65564C11.0732 10.0253 11.3225 10.2574 11.7437 10.266C12.0475 10.2717 12.3512 10.2698 12.655 10.2679Z"
        fill="#FB6B6B"
      />
    </svg>
  );
}

export function TaskIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="25"
      viewBox="0 0 17 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.57742 4.83938H3.61688V6.51272H12.7861V4.83938H14.8259C15.6953 4.83938 16.404 5.54807 16.404 6.417V23.4242C16.404 24.2915 15.6953 25 14.8259 25H1.57762C0.708692 25 0 24.2913 0 23.4242V6.417C0 5.54807 0.708692 4.83938 1.57762 4.83938H1.57742ZM4.48662 3.13124H6.05785C5.95672 2.87264 5.90157 2.59225 5.90157 2.30089C5.90157 1.66935 6.16217 1.09378 6.57526 0.676505L6.57686 0.674107C6.99435 0.261017 7.57073 0 8.20145 0C8.83458 0 9.41296 0.260807 9.82645 0.674107V0.676505C10.2395 1.09379 10.5006 1.66935 10.5006 2.30089C10.5006 2.59227 10.445 2.87288 10.3433 3.13124H11.9169V5.64374H4.48669L4.48662 3.13124ZM8.73105 1.76947C8.59875 1.63717 8.40949 1.55164 8.20142 1.55164C7.99198 1.55164 7.80492 1.63717 7.67042 1.76947C7.53771 1.90357 7.45218 2.09103 7.45218 2.30068C7.45218 2.51053 7.53772 2.69719 7.67042 2.8319C7.80472 2.96419 7.99198 3.04973 8.20142 3.04973C8.40947 3.04973 8.59693 2.96419 8.73105 2.8319C8.86335 2.6972 8.94869 2.51033 8.94869 2.30068C8.94869 2.09084 8.86335 1.90338 8.73105 1.76947ZM5.53662 8.33249V11.893H1.97607V8.33249H5.53662ZM4.28735 9.58294H3.22656V10.6432H4.28735V9.58294ZM6.88462 9.48881H14.4253V10.7389H6.88462V9.48881ZM5.53682 13.6497V17.2106H1.97627V13.6497H5.53682ZM4.28755 14.9001H3.22677V15.9604H4.28755V14.9001ZM6.88483 14.806H14.4256V16.0561H6.88483V14.806ZM5.53702 18.9673V22.5278H1.97648V18.9673H5.53702ZM4.28776 20.2174H3.22697V21.2782H4.28776V20.2174ZM6.88503 20.124H14.4258V21.3737H6.88503V20.124Z"
        fill="#21F3CD"
      />
    </svg>
  );
}

export function ConfimDeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="45"
      viewBox="0 0 40 45"
      fill="none"
    >
      <path
        d="M24.8691 3.4698L27.4266 3.44986L27.41 1.26847C27.4068 0.929462 27.2693 0.605545 27.0277 0.367758C26.786 0.129972 26.46 -0.00227229 26.1209 2.95534e-05L13.511 0.0983691C13.172 0.101177 12.8481 0.238475 12.6103 0.480075C12.3726 0.721675 12.2405 1.0478 12.2432 1.38674L12.2611 3.56814L14.8173 3.54687L14.81 2.64455L24.8618 2.56614L24.8691 3.4698Z"
        fill="#7B7F91"
      />
      <path
        d="M3.0568 11.7716C2.85768 11.7732 2.66133 11.8185 2.48165 11.9043C2.30197 11.9901 2.14335 12.1144 2.01701 12.2683C1.89068 12.4222 1.79971 12.602 1.75055 12.795C1.70139 12.9879 1.69525 13.1893 1.73255 13.3849L7.39501 42.9344C7.45468 43.2465 7.62186 43.5277 7.86745 43.7292C8.11304 43.9308 8.42151 44.0398 8.73919 44.0374L31.6183 43.8587C31.935 43.8567 32.241 43.7443 32.4837 43.5407C32.7263 43.3371 32.8902 43.0553 32.9472 42.7437L38.3458 13.1092C38.3816 12.9127 38.3736 12.7107 38.3224 12.5176C38.2711 12.3246 38.178 12.1452 38.0495 11.9923C37.921 11.8393 37.7603 11.7166 37.579 11.6329C37.3976 11.5492 37.2001 11.5065 37.0003 11.5078L3.0568 11.7716ZM12.8116 42.0314C12.6369 42.0594 12.4584 42.0527 12.2863 42.0116C12.1143 41.9706 11.9519 41.896 11.8087 41.7923C11.6654 41.6885 11.544 41.5575 11.4513 41.4068C11.3587 41.256 11.2966 41.0885 11.2688 40.9138L7.38172 16.5577C7.32532 16.2047 7.41146 15.8438 7.62118 15.5543C7.83089 15.2648 8.14701 15.0705 8.49999 15.0142C8.85296 14.9578 9.21388 15.0439 9.50335 15.2536C9.79282 15.4633 9.98712 15.7795 10.0435 16.1324L13.9306 40.4906C13.9861 40.8432 13.8994 41.2035 13.6897 41.4923C13.4799 41.7812 13.1641 41.9751 12.8116 42.0314ZM20.2661 42.1278C20.089 42.1294 19.9133 42.0961 19.7491 42.0298C19.5848 41.9634 19.4353 41.8653 19.3091 41.741C19.1829 41.6168 19.0824 41.4688 19.0134 41.3057C18.9445 41.1425 18.9084 40.9674 18.9073 40.7902L18.7139 16.1271C18.7263 15.7798 18.8722 15.4506 19.1213 15.2083C19.3704 14.9659 19.7034 14.829 20.051 14.8262C20.3985 14.8234 20.7337 14.9548 20.9867 15.1931C21.2397 15.4314 21.391 15.7581 21.409 16.1052L21.6023 40.7683C21.6051 41.1257 21.466 41.4696 21.2155 41.7245C20.9649 41.9794 20.6235 42.1244 20.2661 42.1278ZM32.7452 16.359L29.2395 40.773C29.1826 41.1214 28.9912 41.4335 28.7066 41.6424C28.4219 41.8512 28.0667 41.9401 27.7173 41.8899C27.3678 41.8397 27.052 41.6544 26.8377 41.3739C26.6234 41.0933 26.5277 40.7399 26.5711 40.3896L30.0761 15.9756C30.1269 15.6217 30.3163 15.3024 30.6025 15.0881C30.8887 14.8738 31.2484 14.7819 31.6023 14.8328C31.9563 14.8836 32.2755 15.073 32.4898 15.3592C32.7042 15.6454 32.796 16.0051 32.7452 16.359Z"
        fill="#7B7F91"
      />
      <path
        d="M0.0318944 10.5116L40 10.1993L39.9681 6.12892L36.2605 6.15749L36.2445 4.01662C36.2426 3.84843 36.1742 3.68783 36.0544 3.56983C35.9345 3.45183 35.7728 3.38601 35.6046 3.38672L27.4266 3.45317L24.8691 3.4731L14.8173 3.54819L12.2611 3.56812L4.63654 3.62726C4.46847 3.62936 4.30803 3.69778 4.19018 3.81763C4.07232 3.93748 4.00659 4.09904 4.00731 4.26712L4.02325 6.40865L0 6.43988L0.0318944 10.5116Z"
        fill="#7B7F91"
      />
      <path
        d="M20.049 14.7696C19.6916 14.7726 19.35 14.9173 19.0992 15.1719C18.8484 15.4266 18.709 15.7703 18.7115 16.1277L18.9048 40.7908C18.9149 41.1436 19.0627 41.4783 19.3167 41.7233C19.5707 41.9682 19.9106 42.1039 20.2634 42.1012C20.6163 42.0985 20.954 41.9577 21.2042 41.7089C21.4544 41.46 21.5972 41.1231 21.6018 40.7702L21.4085 16.1058C21.407 15.9288 21.3707 15.7538 21.3015 15.5908C21.2324 15.4279 21.1318 15.2801 21.0056 15.156C20.8793 15.0319 20.7299 14.9339 20.5657 14.8676C20.4016 14.8013 20.226 14.768 20.049 14.7696Z"
        fill="#F0F0F5"
      />
      <path
        d="M30.0758 15.9769L26.5708 40.3908C26.5274 40.7412 26.6231 41.0946 26.8374 41.3751C27.0517 41.6557 27.3675 41.8409 27.717 41.8911C28.0664 41.9414 28.4216 41.8525 28.7063 41.6436C28.9909 41.4348 29.1823 41.1226 29.2392 40.7742L32.7449 16.3603C32.7957 16.0063 32.7039 15.6467 32.4895 15.3604C32.2752 15.0742 31.956 14.8849 31.602 14.834C31.2481 14.7832 30.8884 14.875 30.6022 15.0893C30.316 15.3037 30.1266 15.6229 30.0758 15.9769Z"
        fill="#F0F0F5"
      />
      <path
        d="M8.50029 15.013C8.32536 15.0407 8.15761 15.1026 8.00664 15.1952C7.85567 15.2877 7.72446 15.4092 7.62052 15.5526C7.51657 15.696 7.44194 15.8585 7.4009 16.0307C7.35986 16.203 7.35322 16.3817 7.38135 16.5566L11.2684 40.9127C11.3245 41.2657 11.5186 41.5819 11.8079 41.7918C12.0971 42.0017 12.4579 42.0881 12.8109 42.032C13.1639 41.9758 13.4801 41.7818 13.69 41.4925C13.8999 41.2032 13.9863 40.8424 13.9302 40.4894L10.0431 16.134C10.0157 15.9589 9.95403 15.791 9.86159 15.6399C9.76914 15.4887 9.64777 15.3573 9.50444 15.2532C9.3611 15.149 9.19861 15.0742 9.0263 15.033C8.85399 14.9918 8.67523 14.985 8.50029 15.013Z"
        fill="#F0F0F5"
      />
    </svg>
  );
}

export function EmployeeInfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <ellipse cx="14.3198" cy="14.32" rx="14.3198" ry="14.32" fill="#FB896B" />
      <path
        d="M13.4893 7.78787C14.0003 7.35717 14.8252 7.35717 15.3216 7.78787L16.475 8.77337C16.694 8.95587 17.1101 9.10917 17.4021 9.10917H18.6431C19.4169 9.10917 20.052 9.74427 20.052 10.5181V11.7591C20.052 12.0511 20.2053 12.4599 20.3878 12.6789L21.3733 13.8323C21.804 14.3433 21.804 15.1682 21.3733 15.6646L20.3878 16.818C20.2053 17.037 20.052 17.4458 20.052 17.7378V18.9788C20.052 19.7526 19.4169 20.3877 18.6431 20.3877H17.4021C17.1101 20.3877 16.7013 20.541 16.4823 20.7235L15.3289 21.709C14.8179 22.1397 13.993 22.1397 13.4966 21.709L12.3432 20.7235C12.1242 20.541 11.7081 20.3877 11.4234 20.3877H10.1459C9.37212 20.3877 8.73702 19.7526 8.73702 18.9788V17.7305C8.73702 17.4458 8.59102 17.0297 8.40852 16.818L7.42302 15.6573C6.99962 15.1536 6.99962 14.336 7.42302 13.8323L8.40852 12.6716C8.59102 12.4526 8.73702 12.0438 8.73702 11.7591V10.5254C8.73702 9.75157 9.37212 9.11647 10.1459 9.11647H11.4088C11.7008 9.11647 12.1096 8.96317 12.3286 8.78067L13.4893 7.78787ZM14.4019 11.3866C14.0004 11.3866 13.6719 11.7151 13.6719 12.1166C13.6719 12.5181 13.9931 12.8466 14.4019 12.8466C14.8034 12.8466 15.1319 12.5181 15.1319 12.1166C15.1319 11.7151 14.8107 11.3866 14.4019 11.3866ZM13.8542 14.234C13.8542 13.9347 14.1024 13.6865 14.4018 13.6865C14.7084 13.6865 14.9493 13.9347 14.9493 14.2413V17.7672C14.9493 18.0665 14.701 18.3147 14.4018 18.3147C14.1024 18.3147 13.8542 18.0665 13.8542 17.7672V14.234Z"
        fill="white"
      />
    </svg>
  );
}

export function SalaryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <rect width="20" height="20" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_4151_6112" transform="scale(0.00390625)" />
        </pattern>
        <image
          id="image0_4151_6112"
          width="256"
          height="256"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

export function PermissionIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.57682 0.75H15.1107C18.8175 0.75 21.0273 2.94291 21.0172 6.62135V15.0898C21.0172 18.7683 18.8073 20.9612 15.1005 20.9612H6.57682C2.86999 20.9612 0.660156 18.7683 0.660156 15.0797V6.62135C0.660156 2.94291 2.86999 0.75 6.57682 0.75ZM9.3574 6.24904C10.8544 4.76352 13.2984 4.76352 14.8056 6.24904C16.3128 7.74467 16.3128 10.17 14.8056 11.6757C13.7567 12.7065 12.2495 13.0198 10.9359 12.6156L9.85639 13.6767C9.75456 13.7676 9.59162 13.7676 9.49997 13.6767L8.51216 12.6964C8.35941 12.5549 8.115 12.5549 7.97243 12.6964C7.82986 12.848 7.82986 13.0905 7.97243 13.232L8.96024 14.2122C9.06207 14.3133 9.06207 14.475 8.96024 14.5659L8.54271 14.9803C8.36959 15.1622 8.03353 15.2632 7.78913 15.2329L6.67911 15.0712C6.31251 15.0207 5.96626 14.6771 5.91535 14.3133L5.76259 13.2118C5.72186 12.9693 5.84406 12.6358 6.007 12.464L8.40014 10.0892C7.9928 8.77544 8.30849 7.27981 9.3574 6.24904ZM10.8442 8.91692C10.8442 9.6142 11.4145 10.1801 12.1172 10.1801C12.8198 10.1801 13.3901 9.6142 13.3901 8.91692C13.3901 8.21963 12.8198 7.65372 12.1172 7.65372C11.4145 7.65372 10.8442 8.21963 10.8442 8.91692Z"
          fill="#996BFB"
        />
      </svg>
    </svg>
  );
}

export const DocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
    >
      <path
        d="M12.0688 0H6.93956C5.80458 0 4.87695 0.916713 4.87695 2.05169V3.07754C4.87695 4.21251 5.79367 5.12922 6.92864 5.12922H12.0688C13.2038 5.12922 14.1205 4.21251 14.1205 3.07754V2.05169C14.1314 0.916713 13.2038 0 12.0688 0Z"
        fill="#2196F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1327 1.79688H4.87822C2.18265 1.79688 0 3.99044 0 6.6751V16.9445C0 19.6291 2.19356 21.8227 4.87822 21.8227H14.1217C16.8173 21.8227 19 19.6291 19 16.9445V6.6751C19.0109 3.97952 16.8173 1.79688 14.1327 1.79688ZM12.78 11.9451H5.14076C4.69332 11.9451 4.32227 11.574 4.32227 11.1266C4.32227 10.6792 4.69332 10.3081 5.14076 10.3081H12.78C13.2275 10.3081 13.5985 10.6792 13.5985 11.1266C13.5985 11.574 13.2275 11.9451 12.78 11.9451ZM5.14076 16.3101H9.92076C10.3682 16.3101 10.7393 15.939 10.7393 15.4916C10.7393 15.0441 10.3682 14.6731 9.92076 14.6731H5.14076C4.69332 14.6731 4.32227 15.0441 4.32227 15.4916C4.32227 15.939 4.69332 16.3101 5.14076 16.3101Z"
        fill="#2196F3"
      />
    </svg>
  );
};

export function GeneralInfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
    >
      <path
        d="M10.1607 0.754671C10.9527 0.0921931 12.2313 0.0921931 13.0008 0.754671L14.7886 2.27051C15.128 2.55122 15.773 2.78702 16.2256 2.78702H18.1491C19.3485 2.78702 20.333 3.76389 20.333 4.95411V6.86294C20.333 7.31208 20.5706 7.94087 20.8535 8.27772L22.381 10.0518C23.0486 10.8378 23.0486 12.1066 22.381 12.8702L20.8535 14.6442C20.5706 14.9811 20.333 15.6099 20.333 16.059V17.9679C20.333 19.1581 19.3485 20.135 18.1491 20.135H16.2256C15.773 20.135 15.1393 20.3708 14.7999 20.6515L13.0121 22.1673C12.22 22.8298 10.9414 22.8298 10.172 22.1673L8.38421 20.6515C8.04476 20.3708 7.3998 20.135 6.95851 20.135H4.97836C3.77896 20.135 2.79455 19.1581 2.79455 17.9679V16.0478C2.79455 15.6099 2.56825 14.9699 2.28537 14.6442L0.757832 12.8589C0.101556 12.0842 0.101556 10.8266 0.757832 10.0518L2.28537 8.2665C2.56825 7.92964 2.79455 7.30085 2.79455 6.86294V4.96533C2.79455 3.77512 3.77896 2.79825 4.97836 2.79825H6.93588C7.38848 2.79825 8.02213 2.56245 8.36158 2.28174L10.1607 0.754671ZM11.5753 6.28826C10.953 6.28826 10.4438 6.79354 10.4438 7.4111C10.4438 8.02867 10.9417 8.53395 11.5753 8.53395C12.1977 8.53395 12.7068 8.02867 12.7068 7.4111C12.7068 6.79354 12.209 6.28826 11.5753 6.28826ZM10.7251 10.6749C10.7251 10.2146 11.1098 9.83281 11.5738 9.83281C12.049 9.83281 12.4224 10.2146 12.4224 10.6862V16.1095C12.4224 16.5699 12.0377 16.9516 11.5738 16.9516C11.1098 16.9516 10.7251 16.5699 10.7251 16.1095V10.6749Z"
        fill="#FB896B"
      />
    </svg>
  );
}

export function RemarksIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
    >
      <path
        d="M17.8389 0.84957L18.1241 1.42558C18.2666 1.70854 18.6231 1.97129 18.9387 2.03192L19.3257 2.09255C20.4867 2.28456 20.7616 3.13343 19.9266 3.97219L19.5701 4.32588C19.3359 4.56842 19.2035 5.03328 19.2748 5.35666L19.3257 5.56888C19.6414 6.96345 18.898 7.49904 17.676 6.77143L17.4112 6.61986C17.0955 6.43795 16.5863 6.43795 16.2706 6.61986L16.0059 6.77143C14.7736 7.50914 14.0303 6.96345 14.3561 5.56888L14.407 5.35666C14.4783 5.03328 14.346 4.56842 14.1117 4.32588L13.7553 3.97219C12.9202 3.13343 13.1952 2.28456 14.3561 2.09255L14.7431 2.03192C15.0486 1.98139 15.4152 1.70854 15.5578 1.42558L15.8429 0.84957C16.3928 -0.25194 17.289 -0.25194 17.8389 0.84957ZM20.4062 7.77031V13.6619C20.4062 17.1988 18.3695 18.7147 15.3144 18.7147H5.13086C2.07578 18.7147 0.0390625 17.1988 0.0390625 13.6619V6.58795C0.0390625 3.051 2.07578 1.53516 5.13086 1.53516H12.3103C12.1066 1.75748 11.9538 2.02023 11.8622 2.31329C11.5669 3.22279 11.8622 4.21315 12.6769 5.0317L12.8704 5.22369C12.4529 7.0528 13.3185 7.91178 13.7156 8.19474C13.9397 8.35643 14.3979 8.60907 15.0497 8.60907C15.5283 8.60907 16.1189 8.4676 16.8012 8.06338L16.842 8.04316L16.8827 8.06338C18.4917 9.02341 19.5814 8.4777 19.9684 8.19474C20.0906 8.11389 20.2535 7.97242 20.4062 7.77031ZM7.8406 10.2052C8.50253 10.7408 9.36813 11.0035 10.2236 11.0035C11.079 11.0035 11.9446 10.7408 12.5963 10.2052C12.9324 9.95257 12.9833 9.4675 12.7185 9.14412C12.4538 8.81064 11.9751 8.76011 11.6493 9.02286C10.8753 9.6393 9.56162 9.6393 8.78767 9.02286L5.6002 6.49646C5.27432 6.23372 4.79571 6.29434 4.53093 6.61772C4.26616 6.9411 4.32726 7.41607 4.65313 7.67881L7.8406 10.2052Z"
        fill="#253CA5"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M5.53125 5.85156C4.96875 5.85156 4.5625 6.32031 4.5625 6.85156C4.5625 7.41406 5 7.85156 5.53125 7.85156C6.0625 7.85156 6.5 7.41406 6.5 6.85156C6.5 6.32031 6.09375 5.85156 5.53125 5.85156ZM9.03125 5.85156C8.46875 5.85156 8.03125 6.32031 8.03125 6.85156C8.03125 7.41406 8.46875 7.85156 9.03125 7.85156C9.59375 7.85156 10 7.41406 10 6.85156C10 6.32031 9.59375 5.85156 9.03125 5.85156ZM12.5312 5.85156C11.9688 5.85156 11.5625 6.32031 11.5625 6.85156C11.5625 7.41406 12 7.85156 12.5312 7.85156C13.0625 7.85156 13.5 7.41406 13.5 6.85156C13.5 6.32031 13.0938 5.85156 12.5312 5.85156ZM14.9688 0.351562H2.96875C1.84375 0.351562 0.96875 1.25781 0.96875 2.35156V11.3203C0.96875 12.4141 1.84375 13.2891 2.96875 13.2891H5.96875V15.8828C5.96875 16.1953 6.3125 16.3516 6.5625 16.1953L10.4688 13.2578H14.9688C16.0625 13.2578 16.9688 12.3516 16.9688 11.2891V2.35156C16.9688 1.25781 16.0938 0.351562 14.9688 0.351562ZM15.5 11.3516C15.5 11.6328 15.25 11.8516 15 11.8516H10L7.5 13.7266V11.8516H3C2.71875 11.8516 2.5 11.6328 2.5 11.3516V2.35156C2.5 2.10156 2.71875 1.85156 3 1.85156H15C15.25 1.85156 15.5 2.10156 15.5 2.35156V11.3516Z"
        fill="#253CA5"
      />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75ZM7 13.4375C3.85547 13.4375 1.3125 10.8945 1.3125 7.75C1.3125 4.63281 3.85547 2.0625 7 2.0625C10.1172 2.0625 12.6875 4.63281 12.6875 7.75C12.6875 10.8945 10.1172 13.4375 7 13.4375ZM8.09375 9.9375H7.65625V7.53125C7.65625 7.17578 7.35547 6.875 7 6.875H6.125C5.74219 6.875 5.46875 7.17578 5.46875 7.53125C5.46875 7.91406 5.74219 8.1875 6.125 8.1875H6.34375V9.9375H5.90625C5.52344 9.9375 5.25 10.2383 5.25 10.5938C5.25 10.9766 5.52344 11.25 5.90625 11.25H8.09375C8.44922 11.25 8.75 10.9766 8.75 10.5938C8.75 10.2383 8.44922 9.9375 8.09375 9.9375ZM7 6C7.46484 6 7.875 5.61719 7.875 5.125C7.875 4.66016 7.46484 4.25 7 4.25C6.50781 4.25 6.125 4.66016 6.125 5.125C6.125 5.61719 6.50781 6 7 6Z"
        fill="#D0D6F1"
      />
    </svg>
  );
}

export function AttacmentIcon1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
    >
      <path
        d="M4 2.75C4 3.46875 3.4375 4 2.75 4H1.25C0.53125 4 0 3.46875 0 2.75V1.25C0 0.5625 0.53125 0 1.25 0H2.75C3.4375 0 4 0.5625 4 1.25V2.75ZM4 8.75C4 9.46875 3.4375 10 2.75 10H1.25C0.53125 10 0 9.46875 0 8.75V7.25C0 6.5625 0.53125 6 1.25 6H2.75C3.4375 6 4 6.5625 4 7.25V8.75ZM5 1.25C5 0.5625 5.53125 0 6.25 0H7.75C8.4375 0 9 0.5625 9 1.25V2.75C9 3.46875 8.4375 4 7.75 4H6.25C5.53125 4 5 3.46875 5 2.75V1.25ZM9 8.75C9 9.46875 8.4375 10 7.75 10H6.25C5.53125 10 5 9.46875 5 8.75V7.25C5 6.5625 5.53125 6 6.25 6H7.75C8.4375 6 9 6.5625 9 7.25V8.75ZM10 1.25C10 0.5625 10.5312 0 11.25 0H12.75C13.4375 0 14 0.5625 14 1.25V2.75C14 3.46875 13.4375 4 12.75 4H11.25C10.5312 4 10 3.46875 10 2.75V1.25ZM14 8.75C14 9.46875 13.4375 10 12.75 10H11.25C10.5312 10 10 9.46875 10 8.75V7.25C10 6.5625 10.5312 6 11.25 6H12.75C13.4375 6 14 6.5625 14 7.25V8.75Z"
        fill="#253CA5"
      />
    </svg>
  );
}

export function AttacmentIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M1.5 9C0.65625 9 0 8.34375 0 7.5V6.5C0 5.6875 0.65625 5 1.5 5H12.5C13.3125 5 14 5.6875 14 6.5V7.5C14 8.34375 13.3125 9 12.5 9H1.5ZM1.5 14C0.65625 14 0 13.3438 0 12.5V11.5C0 10.6875 0.65625 10 1.5 10H6.5C7.3125 10 8 10.6875 8 11.5V12.5C8 13.3438 7.3125 14 6.5 14H1.5ZM12 2.5C12 3.34375 11.3125 4 10.5 4H1.5C0.65625 4 0 3.34375 0 2.5V1.5C0 0.6875 0.65625 0 1.5 0H10.5C11.3125 0 12 0.6875 12 1.5V2.5Z"
        fill="#D0D6F1"
      />
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M2.125 12.2812C2.25 11.8438 2.5 11.4375 2.8125 11.125L12.3125 1.625C13.0938 0.84375 14.375 0.84375 15.1562 1.625L16.375 2.84375C16.4688 2.9375 16.5625 3.0625 16.625 3.15625C17.1562 3.9375 17.0625 5 16.375 5.6875L6.875 15.1875C6.84375 15.2188 6.78125 15.25 6.75 15.3125C6.4375 15.5625 6.09375 15.75 5.71875 15.875L1.9375 16.9688C1.6875 17.0625 1.40625 17 1.21875 16.7812C1 16.5938 0.9375 16.3125 1 16.0625L2.125 12.2812ZM2.84375 15.1562L5.28125 14.4375C5.34375 14.4062 5.4375 14.375 5.5 14.3438L4.375 14.125C4.125 14.0625 3.90625 13.875 3.875 13.625L3.65625 12.5C3.625 12.5625 3.59375 12.6562 3.5625 12.7188L2.84375 15.1562ZM6.625 13.3125L12.9688 6.96875L11 5.03125L4.6875 11.375L5 12.9688L6.625 13.3125Z"
        fill="#7B7F91"
      />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 9.5H12.3125L10.8125 11H14C14.25 11 14.5 11.25 14.5 11.5V14C14.5 14.2812 14.25 14.5 14 14.5H2C1.71875 14.5 1.5 14.2812 1.5 14V11.5C1.5 11.25 1.71875 11 2 11H5.15625L3.65625 9.5H2C0.875 9.5 0 10.4062 0 11.5V14C0 15.125 0.875 16 2 16H14C15.0938 16 16 15.125 16 14V11.5C16 10.4062 15.0938 9.5 14 9.5ZM13.5 12.75C13.5 12.3438 13.1562 12 12.75 12C12.3125 12 12 12.3438 12 12.75C12 13.1875 12.3125 13.5 12.75 13.5C13.1562 13.5 13.5 13.1875 13.5 12.75ZM7.46875 11.5312C7.59375 11.6875 7.78125 11.75 8 11.75C8.1875 11.75 8.375 11.6875 8.5 11.5312L12.75 7.28125C13.0625 7 13.0625 6.53125 12.75 6.25C12.4688 5.9375 12 5.9375 11.7188 6.25L8.75 9.21875V0.75C8.75 0.34375 8.40625 0 8 0C7.5625 0 7.25 0.34375 7.25 0.75V9.21875L4.25 6.21875C3.9375 5.9375 3.46875 5.9375 3.1875 6.21875C2.875 6.53125 2.875 7 3.1875 7.28125L7.46875 11.5312Z"
        fill="#7B7F91"
      />
    </svg>
  );
}

export function DeleteMyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M5 12.5C5 12.7812 4.75 13 4.5 13C4.21875 13 4 12.7812 4 12.5V6C4 5.75 4.21875 5.5 4.5 5.5C4.75 5.5 5 5.75 5 6V12.5ZM7.5 12.5C7.5 12.7812 7.25 13 7 13C6.71875 13 6.5 12.7812 6.5 12.5V6C6.5 5.75 6.71875 5.5 7 5.5C7.25 5.5 7.5 5.75 7.5 6V12.5ZM10 12.5C10 12.7812 9.75 13 9.5 13C9.21875 13 9 12.7812 9 12.5V6C9 5.75 9.21875 5.5 9.5 5.5C9.75 5.5 10 5.75 10 6V12.5ZM9.90625 0.78125L11.0625 2.5H13.25C13.6562 2.5 14 2.84375 14 3.25C14 3.6875 13.6562 4 13.25 4H13V13.5C13 14.9062 11.875 16 10.5 16H3.5C2.09375 16 1 14.9062 1 13.5V4H0.75C0.3125 4 0 3.6875 0 3.25C0 2.84375 0.3125 2.5 0.75 2.5H2.90625L4.0625 0.78125C4.375 0.3125 4.9375 0 5.53125 0H8.4375C9.03125 0 9.59375 0.3125 9.90625 0.78125ZM4.71875 2.5H9.25L8.65625 1.625C8.625 1.5625 8.53125 1.5 8.4375 1.5H5.53125C5.4375 1.5 5.34375 1.5625 5.3125 1.625L4.71875 2.5ZM2.5 13.5C2.5 14.0625 2.9375 14.5 3.5 14.5H10.5C11.0312 14.5 11.5 14.0625 11.5 13.5V4H2.5V13.5Z"
        fill="#ED9A8F"
      />
    </svg>
  );
}

export function PinIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M6.25 11H2C1.6875 11 1.375 10.875 1.1875 10.625C1 10.375 0.9375 10.0625 1 9.78125L1.21875 9C1.53125 7.6875 2.3125 6.625 3.34375 5.90625L3.6875 1.5H2.75C2.59375 1.5 2.46875 1.46875 2.34375 1.40625C2.125 1.28125 2 1.03125 2 0.75C2 0.34375 2.3125 0 2.75 0H11.25C11.6562 0 12 0.34375 12 0.75C12 1.03125 11.8438 1.28125 11.625 1.40625C11.5 1.46875 11.375 1.5 11.25 1.5H10.2812L10.625 5.90625C11.6562 6.625 12.4375 7.6875 12.75 9L12.9688 9.78125C13.0312 10.0625 12.9688 10.375 12.7812 10.625C12.5938 10.875 12.2812 11 12 11H7.75V15.25C7.75 15.6875 7.40625 16 6.96875 16C6.5625 16 6.21875 15.6875 6.21875 15.25L6.25 11ZM4.8125 6.75L4.1875 7.15625C3.46875 7.65625 2.90625 8.4375 2.65625 9.34375L2.625 9.5H6.25V6.75C6.25 6.34375 6.5625 6 7 6C7.40625 6 7.75 6.34375 7.75 6.75V9.5H11.3438L11.3125 9.34375C11.0625 8.4375 10.5 7.65625 9.78125 7.15625L9.15625 6.75L8.78125 1.5H5.1875L4.8125 6.75Z"
        fill="#7B7F91"
      />
    </svg>
  );
}

export function Textareaicon1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.66295 8.764L3.90444 11.5225L4.88426 12.446C5.33426 12.896 5.01557 13.6654 4.3792 13.6654H1.04586C0.651371 13.6654 0.333008 13.3456 0.333008 12.9511V9.61775C0.333008 8.98138 1.10095 8.66269 1.55092 9.11266L2.47586 10.0939L5.23438 7.33542C5.42033 7.14947 5.72185 7.14947 5.9078 7.33542L6.66295 8.09057C6.84893 8.27653 6.84893 8.57801 6.66295 8.764ZM7.3364 5.2334L10.0949 2.47489L9.11509 1.55141C8.66509 1.10141 8.98378 0.332031 9.62015 0.332031H12.9535C13.348 0.332031 13.6663 0.651823 13.6663 1.04632V4.37965C13.6663 5.01602 12.8984 5.33471 12.4484 4.88474L11.5235 3.90346L8.76497 6.66197C8.57902 6.84792 8.2775 6.84792 8.09155 6.66197L7.3364 5.90682C7.15042 5.72087 7.15042 5.41938 7.3364 5.2334Z"
        fill="#7B7F91"
      />
    </svg>
  );
}

export function Textareaicon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M13.6663 6.98608C13.6731 10.6592 10.6776 13.6627 7.00451 13.6653C5.41808 13.6665 3.96088 13.1134 2.81575 12.1892C2.51798 11.9489 2.49572 11.5026 2.76631 11.232L3.06919 10.9292C3.30061 10.6977 3.67007 10.6724 3.92647 10.8758C4.77015 11.5453 5.83787 11.9449 6.99967 11.9449C9.73367 11.9449 11.9459 9.73227 11.9459 6.99869C11.9459 4.26469 9.73324 2.05246 6.99967 2.05246C5.68747 2.05246 4.49567 2.56238 3.61075 3.39472L4.9751 4.75907C5.24607 5.03004 5.05416 5.49332 4.67099 5.49332H0.763115C0.525561 5.49332 0.333008 5.30076 0.333008 5.06321V1.15534C0.333008 0.772165 0.796287 0.580257 1.06725 0.851197L2.39446 2.1784C3.59131 1.03461 5.21343 0.332031 6.99967 0.332031C10.6774 0.332031 13.6595 3.30999 13.6663 6.98608ZM8.80311 9.10393L9.06717 8.76442C9.28593 8.48315 9.23526 8.07781 8.95399 7.85907L7.85988 7.00807V4.203C7.85988 3.84668 7.57104 3.55784 7.21472 3.55784H6.78462C6.4283 3.55784 6.13945 3.84668 6.13945 4.203V7.84952L7.89776 9.2171C8.17902 9.43584 8.58434 9.3852 8.80311 9.10393Z"
        fill="#7B7F91"
      />
    </svg>
  );
}
export function Plusicon({ fill, w, h }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w || "8"}
      height={h || "8"}
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M4.7362 3.4V0.753999H3.2802V3.4H0.620203V4.856H3.2802V7.516L4.7362 7.488V4.856H7.3682V3.4H4.7362Z"
        fill={fill || "#253CA5"}
      />
    </svg>
  );
}
export function GoogleLogo() {
  return (
    <svg
      width="83"
      height="28"
      viewBox="0 0 83 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_149_16)">
        <path
          d="M20.4517 9.84732H10.7819V12.715H17.6443C17.3053 16.7323 13.9555 18.4502 10.7955 18.4502C6.75398 18.4502 3.21428 15.2715 3.21428 10.8212C3.21428 6.49273 6.57767 3.15167 10.7955 3.15167C14.0504 3.15167 15.9762 5.22123 15.9762 5.22123L17.9834 3.13814C17.9834 3.13814 15.4066 0.270508 10.7006 0.270508C4.70611 0.270508 0.0678711 5.31592 0.0678711 10.7671C0.0678711 16.1101 4.43486 21.3179 10.8497 21.3179C16.4916 21.3179 20.628 17.4628 20.628 11.7546C20.628 10.5372 20.4517 9.84732 20.4517 9.84732Z"
          fill="#4285F4"
        />
        <path
          d="M28.3854 7.77734C24.4118 7.77734 21.5637 10.8749 21.5637 14.4865C21.5637 18.1522 24.3304 21.3039 28.4261 21.3039C32.1421 21.3039 35.18 18.4769 35.18 14.5677C35.1936 10.0769 31.6539 7.77734 28.3854 7.77734ZM28.4261 10.4286C30.3791 10.4286 32.2235 11.9976 32.2235 14.5406C32.2235 17.0295 30.3791 18.6392 28.4126 18.6392C26.2426 18.6392 24.5474 16.9078 24.5474 14.5136C24.5474 12.1735 26.2291 10.4286 28.4261 10.4286Z"
          fill="#EA4335"
        />
        <path
          d="M43.2088 7.77734C39.2351 7.77734 36.3871 10.8749 36.3871 14.4865C36.3871 18.1522 39.1537 21.3039 43.2495 21.3039C46.9655 21.3039 50.0034 18.4769 50.0034 14.5677C50.017 10.0769 46.4773 7.77734 43.2088 7.77734ZM43.2495 10.4286C45.2024 10.4286 47.0469 11.9976 47.0469 14.5406C47.0469 17.0295 45.2024 18.6392 43.2359 18.6392C41.066 18.6392 39.3707 16.9078 39.3707 14.5136C39.3707 12.1735 41.0524 10.4286 43.2495 10.4286Z"
          fill="#FBBC05"
        />
        <path
          d="M57.7474 7.77734C54.0992 7.77734 51.2375 10.9561 51.2375 14.5406C51.2375 18.6121 54.5603 21.3039 57.6796 21.3039C59.6054 21.3039 60.6361 20.5329 61.3956 19.6672V21.0063C61.3956 23.3329 59.9716 24.7397 57.8287 24.7397C55.7537 24.7397 54.723 23.1976 54.3568 22.3319L51.7529 23.4141C52.6751 25.3619 54.5331 27.3909 57.8559 27.3909C61.477 27.3909 64.2436 25.1184 64.2436 20.3435V8.18314H61.3956V9.3329C60.5276 8.39957 59.3341 7.77734 57.7474 7.77734ZM58.0186 10.4286C59.8088 10.4286 61.6397 11.9571 61.6397 14.5542C61.6397 17.1918 59.8088 18.6527 57.9779 18.6527C56.0385 18.6527 54.2212 17.0836 54.2212 14.5812C54.2212 11.9841 56.1064 10.4286 58.0186 10.4286Z"
          fill="#4285F4"
        />
        <path
          d="M76.8835 7.76367C73.4388 7.76367 70.5636 10.496 70.5636 14.5134C70.5636 18.7743 73.7778 21.3038 77.2226 21.3038C80.0978 21.3038 81.8473 19.7347 82.9051 18.3414L80.5589 16.7859C79.9486 17.7327 78.9314 18.6526 77.2361 18.6526C75.3239 18.6526 74.4559 17.611 73.9134 16.5965L83 12.8361L82.5254 11.727C81.6438 9.5627 79.596 7.76367 76.8835 7.76367ZM77.0056 10.3608C78.2397 10.3608 79.1348 11.0236 79.5146 11.8081L73.4388 14.3376C73.1811 12.3762 75.0391 10.3608 77.0056 10.3608Z"
          fill="#EA4335"
        />
        <path
          d="M66.2236 20.8983H69.2073V0.973633H66.2236V20.8983Z"
          fill="#34A853"
        />
      </g>
      <defs>
        <clipPath id="clip0_149_16">
          <rect width="83" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SunfocusLogo() {
  return (
    <svg
      width="192"
      height="27"
      viewBox="0 0 192 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5632 8.38423C15.4666 7.41027 15.0521 6.65365 14.3196 6.11435C13.5871 5.57505 12.593 5.3054 11.3374 5.3054C10.4841 5.3054 9.76373 5.42614 9.17614 5.66761C8.58854 5.90104 8.13778 6.22704 7.82386 6.6456C7.51799 7.06416 7.36506 7.53906 7.36506 8.07031C7.34896 8.51302 7.44152 8.89938 7.64276 9.2294C7.85204 9.55942 8.13778 9.84517 8.5 10.0866C8.86222 10.3201 9.28078 10.5253 9.75568 10.7024C10.2306 10.8714 10.7377 11.0163 11.277 11.1371L13.4986 11.6683C14.5772 11.9098 15.5672 12.2318 16.4688 12.6342C17.3703 13.0367 18.151 13.5317 18.8111 14.1193C19.4711 14.7069 19.9822 15.3991 20.3445 16.196C20.7147 16.9929 20.9039 17.9065 20.9119 18.9368C20.9039 20.45 20.5175 21.7621 19.7528 22.8729C18.9962 23.9756 17.9015 24.8329 16.4688 25.4446C15.044 26.0483 13.3255 26.3501 11.3132 26.3501C9.317 26.3501 7.57836 26.0443 6.0973 25.4325C4.62429 24.8208 3.47325 23.9152 2.64418 22.7159C1.82315 21.5085 1.39252 20.0154 1.35227 18.2365H6.41122C6.46757 19.0656 6.70502 19.7578 7.12358 20.3132C7.55019 20.8606 8.11766 21.2751 8.82599 21.5568C9.54238 21.8305 10.3513 21.9673 11.2528 21.9673C12.1383 21.9673 12.907 21.8385 13.5589 21.581C14.219 21.3234 14.7301 20.9652 15.0923 20.5064C15.4545 20.0476 15.6357 19.5204 15.6357 18.9247C15.6357 18.3693 15.4706 17.9025 15.1406 17.5241C14.8187 17.1458 14.3438 16.8239 13.7159 16.5582C13.0961 16.2926 12.3355 16.0511 11.4339 15.8338L8.74148 15.1577C6.65672 14.6506 5.01065 13.8577 3.80327 12.7791C2.59588 11.7005 1.99621 10.2476 2.00426 8.42045C1.99621 6.92329 2.39465 5.61529 3.19957 4.49645C4.01255 3.3776 5.12737 2.50426 6.54403 1.87642C7.9607 1.24858 9.57055 0.934658 11.3736 0.934658C13.2088 0.934658 14.8106 1.24858 16.179 1.87642C17.5554 2.50426 18.6259 3.3776 19.3906 4.49645C20.1553 5.61529 20.5497 6.91122 20.5739 8.38423H15.5632ZM39.8019 1.27273H45.0299V17.331C45.0299 19.134 44.5992 20.7116 43.738 22.0639C42.8847 23.4162 41.6894 24.4706 40.152 25.2273C38.6146 25.9759 36.8237 26.3501 34.7792 26.3501C32.7266 26.3501 30.9316 25.9759 29.3942 25.2273C27.8568 24.4706 26.6615 23.4162 25.8083 22.0639C24.9551 20.7116 24.5284 19.134 24.5284 17.331V1.27273H29.7564V16.8842C29.7564 17.826 29.9617 18.6631 30.3722 19.3956C30.7908 20.1281 31.3784 20.7036 32.135 21.1222C32.8916 21.5407 33.773 21.75 34.7792 21.75C35.7934 21.75 36.6748 21.5407 37.4233 21.1222C38.18 20.7036 38.7635 20.1281 39.174 19.3956C39.5926 18.6631 39.8019 17.826 39.8019 16.8842V1.27273ZM70.1137 1.27273V26H65.5981L54.8403 10.4368H54.6592V26H49.4312V1.27273H54.0192L64.6925 16.8239H64.9099V1.27273H70.1137ZM74.5331 26V1.27273H90.9053V5.5831H79.7611V11.4751H89.8186V15.7855H79.7611V26H74.5331ZM117.245 13.6364C117.245 16.3329 116.734 18.6269 115.711 20.5185C114.697 22.41 113.313 23.8549 111.558 24.853C109.811 25.843 107.847 26.3381 105.666 26.3381C103.469 26.3381 101.496 25.839 99.7498 24.8409C98.0031 23.8428 96.6227 22.398 95.6085 20.5064C94.5942 18.6148 94.0871 16.3248 94.0871 13.6364C94.0871 10.9399 94.5942 8.64583 95.6085 6.75426C96.6227 4.86269 98.0031 3.42187 99.7498 2.43182C101.496 1.43371 103.469 0.934658 105.666 0.934658C107.847 0.934658 109.811 1.43371 111.558 2.43182C113.313 3.42187 114.697 4.86269 115.711 6.75426C116.734 8.64583 117.245 10.9399 117.245 13.6364ZM111.944 13.6364C111.944 11.8897 111.683 10.4167 111.16 9.21733C110.644 8.01799 109.916 7.10843 108.974 6.48864C108.032 5.86885 106.93 5.55895 105.666 5.55895C104.402 5.55895 103.3 5.86885 102.358 6.48864C101.416 7.10843 100.684 8.01799 100.16 9.21733C99.6451 10.4167 99.3876 11.8897 99.3876 13.6364C99.3876 15.383 99.6451 16.8561 100.16 18.0554C100.684 19.2547 101.416 20.1643 102.358 20.7841C103.3 21.4039 104.402 21.7138 105.666 21.7138C106.93 21.7138 108.032 21.4039 108.974 20.7841C109.916 20.1643 110.644 19.2547 111.16 18.0554C111.683 16.8561 111.944 15.383 111.944 13.6364ZM143.035 9.92969H137.747C137.65 9.2455 137.453 8.63778 137.155 8.10653C136.857 7.56723 136.475 7.10843 136.008 6.73011C135.541 6.3518 135.002 6.06203 134.39 5.86079C133.786 5.65956 133.13 5.55895 132.422 5.55895C131.142 5.55895 130.027 5.87689 129.078 6.51278C128.128 7.14062 127.391 8.05824 126.868 9.26562C126.345 10.465 126.083 11.9219 126.083 13.6364C126.083 15.3991 126.345 16.8802 126.868 18.0795C127.399 19.2789 128.14 20.1844 129.09 20.7962C130.039 21.4079 131.138 21.7138 132.386 21.7138C133.086 21.7138 133.734 21.6212 134.33 21.4361C134.933 21.2509 135.469 20.9813 135.936 20.6271C136.402 20.2649 136.789 19.8262 137.095 19.3111C137.409 18.7959 137.626 18.2083 137.747 17.5483L143.035 17.5724C142.898 18.7074 142.556 19.8021 142.009 20.8565C141.469 21.9029 140.741 22.8407 139.823 23.6697C138.914 24.4908 137.827 25.1428 136.563 25.6257C135.308 26.1006 133.887 26.3381 132.301 26.3381C130.096 26.3381 128.124 25.839 126.385 24.8409C124.655 23.8428 123.286 22.398 122.28 20.5064C121.282 18.6148 120.783 16.3248 120.783 13.6364C120.783 10.9399 121.29 8.64583 122.304 6.75426C123.318 4.86269 124.695 3.42187 126.433 2.43182C128.172 1.43371 130.128 0.934658 132.301 0.934658C133.734 0.934658 135.062 1.13589 136.286 1.53835C137.517 1.94081 138.608 2.52841 139.558 3.30113C140.508 4.06581 141.28 5.00355 141.876 6.11435C142.48 7.22514 142.866 8.49692 143.035 9.92969ZM162.157 1.27273H167.385V17.331C167.385 19.134 166.955 20.7116 166.093 22.0639C165.24 23.4162 164.045 24.4706 162.508 25.2273C160.97 25.9759 159.179 26.3501 157.135 26.3501C155.082 26.3501 153.287 25.9759 151.75 25.2273C150.212 24.4706 149.017 23.4162 148.164 22.0639C147.311 20.7116 146.884 19.134 146.884 17.331V1.27273H152.112V16.8842C152.112 17.826 152.317 18.6631 152.728 19.3956C153.146 20.1281 153.734 20.7036 154.49 21.1222C155.247 21.5407 156.128 21.75 157.135 21.75C158.149 21.75 159.03 21.5407 159.779 21.1222C160.535 20.7036 161.119 20.1281 161.53 19.3956C161.948 18.6631 162.157 17.826 162.157 16.8842V1.27273ZM185.201 8.38423C185.104 7.41027 184.69 6.65365 183.957 6.11435C183.225 5.57505 182.231 5.3054 180.975 5.3054C180.122 5.3054 179.401 5.42614 178.814 5.66761C178.226 5.90104 177.775 6.22704 177.461 6.6456C177.155 7.06416 177.003 7.53906 177.003 8.07031C176.986 8.51302 177.079 8.89938 177.28 9.2294C177.49 9.55942 177.775 9.84517 178.137 10.0866C178.5 10.3201 178.918 10.5253 179.393 10.7024C179.868 10.8714 180.375 11.0163 180.914 11.1371L183.136 11.6683C184.215 11.9098 185.205 12.2318 186.106 12.6342C187.008 13.0367 187.789 13.5317 188.449 14.1193C189.109 14.7069 189.62 15.3991 189.982 16.196C190.352 16.9929 190.541 17.9065 190.549 18.9368C190.541 20.45 190.155 21.7621 189.39 22.8729C188.634 23.9756 187.539 24.8329 186.106 25.4446C184.682 26.0483 182.963 26.3501 180.951 26.3501C178.954 26.3501 177.216 26.0443 175.735 25.4325C174.262 24.8208 173.111 23.9152 172.282 22.7159C171.461 21.5085 171.03 20.0154 170.99 18.2365H176.049C176.105 19.0656 176.343 19.7578 176.761 20.3132C177.188 20.8606 177.755 21.2751 178.463 21.5568C179.18 21.8305 179.989 21.9673 180.89 21.9673C181.776 21.9673 182.544 21.8385 183.196 21.581C183.856 21.3234 184.368 20.9652 184.73 20.5064C185.092 20.0476 185.273 19.5204 185.273 18.9247C185.273 18.3693 185.108 17.9025 184.778 17.5241C184.456 17.1458 183.981 16.8239 183.353 16.5582C182.734 16.2926 181.973 16.0511 181.071 15.8338L178.379 15.1577C176.294 14.6506 174.648 13.8577 173.441 12.7791C172.233 11.7005 171.634 10.2476 171.642 8.42045C171.634 6.92329 172.032 5.61529 172.837 4.49645C173.65 3.3776 174.765 2.50426 176.182 1.87642C177.598 1.24858 179.208 0.934658 181.011 0.934658C182.846 0.934658 184.448 1.24858 185.816 1.87642C187.193 2.50426 188.263 3.3776 189.028 4.49645C189.793 5.61529 190.187 6.91122 190.211 8.38423H185.201Z"
        fill="#0000E9"
      />
      <path
        d="M105.475 14.5L99.9755 9C92.7755 15 96.9755 19.1667 99.9755 20.5L105.475 14.5Z"
        fill="#0000E9"
      />
    </svg>
  );
}

export function ProjectsIcon({ w, h, fill }) {
  return (
    <svg
      width={w || "14"}
      height={h || "15"}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 0H1.4C0.63 0 0.00699999 0.646334 0.00699999 1.4363L0 14.363L2.8 11.4904H12.6C13.37 11.4904 14 10.844 14 10.0541V1.4363C14 0.646334 13.37 0 12.6 0ZM11.2 8.61779H2.8V7.18149H11.2V8.61779ZM11.2 6.46334H2.8V5.02704H11.2V6.46334ZM11.2 4.30889H2.8V2.8726H11.2V4.30889Z"
        fill={fill || "#8F8F8F"}
      />
    </svg>
  );
}

export function ReportingIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4444 1.43629H9.19333C8.86667 0.603244 8.01111 0 7 0C5.98889 0 5.13333 0.603244 4.80667 1.43629H1.55556C0.7 1.43629 0 2.08263 0 2.87259V12.9267C0 13.7166 0.7 14.3629 1.55556 14.3629H12.4444C13.3 14.3629 14 13.7166 14 12.9267V2.87259C14 2.08263 13.3 1.43629 12.4444 1.43629ZM7 1.43629C7.42778 1.43629 7.77778 1.75946 7.77778 2.15444C7.77778 2.54942 7.42778 2.87259 7 2.87259C6.57222 2.87259 6.22222 2.54942 6.22222 2.15444C6.22222 1.75946 6.57222 1.43629 7 1.43629ZM8.55556 11.4904H3.11111V10.0541H8.55556V11.4904ZM10.8889 8.61777H3.11111V7.18147H10.8889V8.61777ZM10.8889 5.74518H3.11111V4.30888H10.8889V5.74518Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}

export function EmployeesIcon() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9091 4.8365C12.1164 4.8365 13.0836 3.75635 13.0836 2.41825C13.0836 1.08015 12.1164 0 10.9091 0C9.70182 0 8.72727 1.08015 8.72727 2.41825C8.72727 3.75635 9.70182 4.8365 10.9091 4.8365ZM5.09091 4.8365C6.29818 4.8365 7.26545 3.75635 7.26545 2.41825C7.26545 1.08015 6.29818 0 5.09091 0C3.88364 0 2.90909 1.08015 2.90909 2.41825C2.90909 3.75635 3.88364 4.8365 5.09091 4.8365ZM5.09091 6.44867C3.39636 6.44867 0 7.39179 0 9.26996V11.2852H10.1818V9.26996C10.1818 7.39179 6.78545 6.44867 5.09091 6.44867ZM10.9091 6.44867C10.6982 6.44867 10.4582 6.46479 10.2036 6.48897C11.0473 7.16608 11.6364 8.07696 11.6364 9.26996V11.2852H16V9.26996C16 7.39179 12.6036 6.44867 10.9091 6.44867Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}

export function LmsIcon() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9091 4.8365C12.1164 4.8365 13.0836 3.75635 13.0836 2.41825C13.0836 1.08015 12.1164 0 10.9091 0C9.70182 0 8.72727 1.08015 8.72727 2.41825C8.72727 3.75635 9.70182 4.8365 10.9091 4.8365ZM5.09091 4.8365C6.29818 4.8365 7.26545 3.75635 7.26545 2.41825C7.26545 1.08015 6.29818 0 5.09091 0C3.88364 0 2.90909 1.08015 2.90909 2.41825C2.90909 3.75635 3.88364 4.8365 5.09091 4.8365ZM5.09091 6.44867C3.39636 6.44867 0 7.39179 0 9.26996V11.2852H10.1818V9.26996C10.1818 7.39179 6.78545 6.44867 5.09091 6.44867ZM10.9091 6.44867C10.6982 6.44867 10.4582 6.46479 10.2036 6.48897C11.0473 7.16608 11.6364 8.07696 11.6364 9.26996V11.2852H16V9.26996C16 7.39179 12.6036 6.44867 10.9091 6.44867Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}

export function NotificationIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14.3629C7.9625 14.3629 8.75 13.7 8.75 12.8898H5.25C5.25 13.7 6.02875 14.3629 7 14.3629ZM12.25 9.94356V6.26076C12.25 3.99952 10.815 2.10656 8.3125 1.6057V1.10484C8.3125 0.493495 7.72625 0 7 0C6.27375 0 5.6875 0.493495 5.6875 1.10484V1.6057C3.17625 2.10656 1.75 3.99215 1.75 6.26076V9.94356L0 11.4167V12.1532H14V11.4167L12.25 9.94356Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}

export function SettingIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3485 7.88527C12.3773 7.65547 12.3989 7.42566 12.3989 7.18149C12.3989 6.93732 12.3773 6.70751 12.3485 6.4777L13.8669 5.29276C14.0037 5.18503 14.0396 4.99113 13.9533 4.83314L12.514 2.34835C12.4277 2.19035 12.2334 2.1329 12.075 2.19035L10.2831 2.9085C9.90892 2.62124 9.50593 2.38425 9.06695 2.20472L8.79349 0.301623C8.7719 0.129267 8.62077 0 8.44086 0H5.56231C5.38241 0 5.23128 0.129267 5.20969 0.301623L4.93623 2.20472C4.49725 2.38425 4.09425 2.62842 3.72004 2.9085L1.92815 2.19035C1.76263 2.12572 1.57552 2.19035 1.48917 2.34835L0.0498936 4.83314C-0.0436593 4.99113 -0.000480935 5.18503 0.13625 5.29276L1.65468 6.4777C1.6259 6.70751 1.60431 6.9445 1.60431 7.18149C1.60431 7.41848 1.6259 7.65547 1.65468 7.88527L0.13625 9.07022C-0.000480935 9.17794 -0.0364629 9.37184 0.0498936 9.52984L1.48917 12.0146C1.57552 12.1726 1.76983 12.2301 1.92815 12.1726L3.72004 11.4545C4.09425 11.7417 4.49725 11.9787 4.93623 12.1583L5.20969 14.0614C5.23128 14.2337 5.38241 14.363 5.56231 14.363H8.44086C8.62077 14.363 8.7719 14.2337 8.79349 14.0614L9.06695 12.1583C9.50593 11.9787 9.90892 11.7346 10.2831 11.4545L12.075 12.1726C12.2405 12.2373 12.4277 12.1726 12.514 12.0146L13.9533 9.52984C14.0396 9.37184 14.0037 9.17794 13.8669 9.07022L12.3485 7.88527ZM7.00159 9.69501C5.61269 9.69501 4.48286 8.56752 4.48286 7.18149C4.48286 5.79546 5.61269 4.66797 7.00159 4.66797C8.39049 4.66797 9.52032 5.79546 9.52032 7.18149C9.52032 8.56752 8.39049 9.69501 7.00159 9.69501Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}

export function HomeIcon({ height, width }) {
  return (
    <svg
      width={width || "14"}
      height={height || "15"}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7649 6.38119L7.48352 0.203395C7.20782 -0.0678082 6.79206 -0.0677787 6.51646 0.203366L0.235102 6.38122C0.0142472 6.59844 -0.0587056 6.93313 0.0491924 7.23385C0.157118 7.53456 0.41989 7.72885 0.718674 7.72885H1.72191V13.9185C1.72191 14.1639 1.90626 14.3629 2.13363 14.3629H5.57658C5.80394 14.3629 5.98829 14.164 5.98829 13.9185V10.1604H8.01177V13.9186C8.01177 14.164 8.19613 14.363 8.42349 14.363H11.8663C12.0936 14.363 12.278 14.164 12.278 13.9186V7.72885H13.2814C13.5802 7.72885 13.843 7.53453 13.9509 7.23385C14.0587 6.9331 13.9857 6.59844 13.7649 6.38119Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}
export function SidebarSelected() {
  return (
    <svg
      width="4"
      height="32"
      viewBox="0 0 4 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0336104 0.0471035C1.96374 0.0446607 3.54327 1.62245 3.54328 3.5529L3.54329 28.5313C3.54329 30.4703 1.97255 32.0223 0.0336104 31.9989L0.0336104 0.0471035Z"
        fill="#0000E9"
      />
    </svg>
  );
}

export function SidebarArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 17L9 12L14 7" stroke="#8389A3" strokeWidth="1.5" />
    </svg>
  );
}

export function SearchIcon({ fill }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5006 11.0006H11.7106L11.4306 10.7306C12.6306 9.33063 13.2506 7.42063 12.9106 5.39063C12.4406 2.61063 10.1206 0.390626 7.32063 0.0506256C3.09063 -0.469374 -0.469374 3.09063 0.0506256 7.32063C0.390626 10.1206 2.61063 12.4406 5.39063 12.9106C7.42063 13.2506 9.33063 12.6306 10.7306 11.4306L11.0006 11.7106V12.5006L15.2506 16.7506C15.6606 17.1606 16.3306 17.1606 16.7406 16.7506C17.1506 16.3406 17.1506 15.6706 16.7406 15.2606L12.5006 11.0006ZM6.50063 11.0006C4.01063 11.0006 2.00063 8.99063 2.00063 6.50063C2.00063 4.01063 4.01063 2.00063 6.50063 2.00063C8.99063 2.00063 11.0006 4.01063 11.0006 6.50063C11.0006 8.99063 8.99063 11.0006 6.50063 11.0006Z"
        fill={fill || "#7B7F91"}
      />
    </svg>
  );
}

export function WindowIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.789062 0H10.7891V10H0.789062V0Z" fill="white" />
      <path d="M0.789062 14H10.7891V24H0.789062V14Z" fill="white" />
      <path d="M14.7891 0H24.7891V10H14.7891V0Z" fill="white" />
      <path d="M14.7891 14H24.7891V24H14.7891V14Z" fill="white" />
    </svg>
  );
}

export function CompletedIcon() {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3333 2.6H15.76C15.2 1.092 13.7333 0 12 0C10.2667 0 8.8 1.092 8.24 2.6H2.66667C1.2 2.6 0 3.77 0 5.2V23.4C0 24.83 1.2 26 2.66667 26H21.3333C22.8 26 24 24.83 24 23.4V5.2C24 3.77 22.8 2.6 21.3333 2.6ZM12 2.6C12.7333 2.6 13.3333 3.185 13.3333 3.9C13.3333 4.615 12.7333 5.2 12 5.2C11.2667 5.2 10.6667 4.615 10.6667 3.9C10.6667 3.185 11.2667 2.6 12 2.6ZM9.33333 20.8L4 15.6L5.88 13.767L9.33333 17.121L18.12 8.554L20 10.4L9.33333 20.8Z"
        fill="white"
      />
    </svg>
  );
}

export function OnHoldIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9733 0H7.02667L0 7.02667V16.9733L7.02667 24H16.9733L24 16.9733V7.02667L16.9733 0ZM12 19.0667C11.04 19.0667 10.2667 18.2933 10.2667 17.3333C10.2667 16.3733 11.04 15.6 12 15.6C12.96 15.6 13.7333 16.3733 13.7333 17.3333C13.7333 18.2933 12.96 19.0667 12 19.0667ZM13.3333 13.3333H10.6667V5.33333H13.3333V13.3333Z"
        fill="white"
      />
    </svg>
  );
}

export function DownArrow() {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42773 1.28516L5.99916 5.85658L10.5706 1.28516"
        stroke="#7B7F91"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const RedCrossIcon = ({ fill }) => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.73605 0H0.0302325L4.93546 6L0 12H2.72093L6.43953 7.37109H6.56046L10.2791 12H13L8.14767 6L12.9698 0H10.264L6.56046 4.69336H6.43953L2.73605 0Z"
      fill={fill || "#E75151"}
    />
  </svg>
);

export const FileAction = ({ fill }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 6.1425H11.3325C9.555 6.1425 8.1075 4.695 8.1075 2.9175V0.75C8.1075 0.3375 7.77 0 7.3575 0H4.1775C1.8675 0 0 1.5 0 4.1775V10.8225C0 13.5 1.8675 15 4.1775 15H10.0725C12.3825 15 14.25 13.5 14.25 10.8225V6.8925C14.25 6.48 13.9125 6.1425 13.5 6.1425Z"
      fill={fill || "white"}
    />
    <path
      d="M9.97477 0.157861C9.66727 -0.149639 9.13477 0.0603611 9.13477 0.487861V3.10536C9.13477 4.20036 10.0648 5.10786 11.1973 5.10786C11.9098 5.11536 12.8998 5.11536 13.7473 5.11536C14.1748 5.11536 14.3998 4.61286 14.0998 4.31286C13.0198 3.22536 11.0848 1.26786 9.97477 0.157861Z"
      fill={fill || "white"}
    />
    <path
      d="M8.25 8.8125H3.75C3.4425 8.8125 3.1875 8.5575 3.1875 8.25C3.1875 7.9425 3.4425 7.6875 3.75 7.6875H8.25C8.5575 7.6875 8.8125 7.9425 8.8125 8.25C8.8125 8.5575 8.5575 8.8125 8.25 8.8125Z"
      fill="#FB896B"
    />
    <path
      d="M6.75 11.8125H3.75C3.4425 11.8125 3.1875 11.5575 3.1875 11.25C3.1875 10.9425 3.4425 10.6875 3.75 10.6875H6.75C7.0575 10.6875 7.3125 10.9425 7.3125 11.25C7.3125 11.5575 7.0575 11.8125 6.75 11.8125Z"
      fill="#FB896B"
    />
  </svg>
);

export const FlagIcon = ({ fill }) => (
  <svg
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.6375 17C0.289 17 0 16.711 0 16.3625V0.6375C0 0.289 0.289 0 0.6375 0C0.986 0 1.275 0.289 1.275 0.6375V16.3625C1.275 16.711 0.986 17 0.6375 17Z"
      fill={fill || "white"}
    />
    <path
      d="M11.577 8.77919L10.54 7.74219C10.2935 7.52969 10.149 7.21519 10.1405 6.86669C10.1235 6.48419 10.2765 6.10169 10.557 5.82119L11.577 4.80119C12.461 3.91719 12.7925 3.06719 12.512 2.39569C12.24 1.73269 11.3985 1.36719 10.1575 1.36719H0.637453C0.458953 1.37569 0.314453 1.52019 0.314453 1.69869V11.8987C0.314453 12.0772 0.458953 12.2217 0.637453 12.2217H10.1575C11.3815 12.2217 12.206 11.8477 12.4865 11.1762C12.767 10.4962 12.444 9.65469 11.577 8.77919Z"
      fill={fill || "white"}
    />
  </svg>
);

export const CylenderIcon = ({ fill }) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52932 0H5.47993C4.5839 0 3.85156 0.723721 3.85156 1.61976V2.42963C3.85156 3.32567 4.57528 4.04939 5.47132 4.04939H9.52932C10.4254 4.04939 11.1491 3.32567 11.1491 2.42963V1.61976C11.1577 0.723721 10.4254 0 9.52932 0Z"
      fill={fill || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1574 1.42188H3.85123C1.72314 1.42188 0 3.15363 0 5.2731V13.3805C0 15.5 1.73176 17.2317 3.85123 17.2317H11.1487C13.2768 17.2317 15 15.5 15 13.3805V5.2731C15.0086 3.14502 13.2768 1.42188 11.1574 1.42188ZM10.089 9.43445H4.05804C3.7048 9.43445 3.41187 9.14151 3.41187 8.78827C3.41187 8.43502 3.7048 8.14209 4.05804 8.14209H10.089C10.4423 8.14209 10.7352 8.43502 10.7352 8.78827C10.7352 9.14151 10.4423 9.43445 10.089 9.43445ZM4.05804 12.8807H7.83173C8.18497 12.8807 8.47791 12.5878 8.47791 12.2346C8.47791 11.8813 8.18497 11.5884 7.83173 11.5884H4.05804C3.7048 11.5884 3.41187 11.8813 3.41187 12.2346C3.41187 12.5878 3.7048 12.8807 4.05804 12.8807Z"
      fill={fill || "white"}
    />
  </svg>
);

export const UserGroup = ({ fill }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2389 1.25228C10.2389 1.91367 9.70273 2.44988 9.04135 2.44988C8.37996 2.44988 7.84375 1.91367 7.84375 1.25228C7.84375 0.590902 8.37996 0.0546875 9.04135 0.0546875C9.70273 0.0546875 10.2389 0.590902 10.2389 1.25228Z"
      fill={fill || "white"}
    />
    <path
      d="M10.1855 1.25079C10.1798 1.72523 9.88514 2.16143 9.43554 2.32595C8.98786 2.48856 8.47323 2.35082 8.16714 1.98733C7.85721 1.62001 7.81322 1.08051 8.06 0.667291C8.30488 0.255964 8.79464 0.0359585 9.26334 0.129712C9.7971 0.234933 10.1797 0.709375 10.1854 1.2508C10.1854 1.31968 10.2945 1.31968 10.2926 1.2508C10.2868 0.730435 9.96353 0.259813 9.47377 0.0761536C8.9802 -0.107505 8.40435 0.0493701 8.07146 0.45687C7.74241 0.860535 7.69648 1.4402 7.96241 1.88787C8.23024 2.33747 8.76208 2.57469 9.27482 2.47712C9.86215 2.36616 10.283 1.84005 10.2907 1.24891C10.2926 1.18195 10.1854 1.18193 10.1854 1.2508L10.1855 1.25079Z"
      fill={fill || "white"}
    />
    <path
      d="M11.2372 5.37479H6.84476C6.66493 5.37479 6.51953 5.2294 6.51953 5.04956V4.83147C6.51953 3.73332 7.40914 2.84375 8.50725 2.84375H9.57478C10.6729 2.84375 11.5625 3.73336 11.5625 4.83147V5.04956C11.5644 5.22939 11.4171 5.37479 11.2373 5.37479H11.2372Z"
      fill={fill || "white"}
    />
    <path
      d="M11.2372 5.31798H9.61683H7.21779C7.03413 5.31798 6.72803 5.37155 6.61325 5.1898C6.55586 5.09797 6.57116 4.97936 6.57116 4.87605C6.57116 4.74979 6.5769 4.62352 6.59795 4.49918C6.6496 4.19691 6.77395 3.91186 6.9576 3.66698C7.32111 3.18104 7.90077 2.896 8.50723 2.89407C8.84585 2.89216 9.18446 2.89407 9.52309 2.89407C10.0721 2.89407 10.5944 3.09495 10.977 3.49672C11.1856 3.71482 11.3405 3.98266 11.4285 4.27344C11.5012 4.52023 11.5127 4.77086 11.5089 5.02529C11.507 5.18408 11.4037 5.31033 11.2372 5.31798C11.1684 5.3199 11.1683 5.42896 11.2372 5.42513C11.3864 5.41939 11.5223 5.33904 11.5835 5.19938C11.6275 5.0999 11.616 4.98894 11.616 4.88372C11.616 4.59101 11.5701 4.30787 11.4572 4.03812C11.2162 3.46227 10.7111 3.01844 10.1085 2.85581C9.69333 2.74293 9.23607 2.78503 8.80946 2.78503C8.63727 2.78503 8.46509 2.77737 8.2929 2.7965C7.97724 2.83094 7.67115 2.93616 7.40329 3.10834C6.87719 3.44696 6.52901 4.01709 6.4716 4.64076C6.46012 4.75746 6.46203 4.87225 6.46203 4.98894C6.46203 5.11138 6.48308 5.22426 6.573 5.31418C6.66674 5.40792 6.78344 5.42514 6.90779 5.42514H9.09638C9.79659 5.42514 10.4987 5.4347 11.1989 5.42514H11.2353C11.308 5.42514 11.308 5.318 11.2372 5.318L11.2372 5.31798Z"
      fill={fill || "white"}
    />
    <path
      d="M10.2389 13.5257C10.2389 14.1871 9.70273 14.7233 9.04135 14.7233C8.37996 14.7233 7.84375 14.1871 7.84375 13.5257C7.84375 12.8643 8.37996 12.3281 9.04135 12.3281C9.70273 12.3281 10.2389 12.8643 10.2389 13.5257Z"
      fill={fill || "white"}
    />
    <path
      d="M10.1855 13.5242C10.1798 13.9987 9.88514 14.4349 9.43554 14.5994C8.98786 14.762 8.47323 14.6243 8.16714 14.2608C7.85721 13.8934 7.81322 13.3539 8.06 12.9407C8.30488 12.5294 8.79464 12.3094 9.26334 12.4031C9.7971 12.5084 10.1a797 12.9828 10.1854 13.5242C10.1854 13.5931 10.2945 13.5931 10.2926 13.5242C10.2868 13.0039 9.96353 12.5333 9.47377 12.3496C8.9802 12.1659 8.40435 12.3228 8.07146 12.7303C7.74241 13.134 7.69648 13.7136 7.96241 14.1613C8.23024 14.6109 8.76208 14.8481 9.27482 14.7506C9.86215 14.6396 10.283 14.1135 10.2907 13.5224C10.2926 13.4554 10.1854 13.4554 10.1854 13.5242L10.1855 13.5242Z"
      fill={fill || "white"}
    />
    <path
      d="M11.2372 17.6482H6.84476C6.66493 17.6482 6.51953 17.5028 6.51953 17.323V17.1049C6.51953 16.0068 7.40914 15.1172 8.50725 15.1172H9.57478C10.6729 15.1172 11.5625 16.0068 11.5625 17.1049V17.323C11.5644 17.5028 11.4171 17.6482 11.2373 17.6482H11.2372Z"
      fill={fill || "white"}
    />
    <path
      d="M11.2372 17.5953H9.61683H7.21779C7.03413 17.5953 6.72803 17.6489 6.61325 17.4671C6.55586 17.3753 6.57116 17.2567 6.57116 17.1534C6.57116 17.0271 6.5769 16.9009 6.59795 16.7765C6.6496 16.4743 6.77395 16.1892 6.9576 15.9443C7.32111 15.4584 7.90077 15.1733 8.50723 15.1714C8.84585 15.1695 9.18446 15.1714 9.52309 15.1714C10.0721 15.1714 10.5944 15.3723 10.977 15.7741C11.1856 15.9922 11.3405 16.26 11.4285 16.5508C11.5012 16.7976 11.5127 17.0482 11.5089 17.3026C11.507 17.4614 11.4037 17.5877 11.2372 17.5953C11.1684 17.5972 11.1683 17.7063 11.2372 17.7025C11.3864 17.6967 11.5223 17.6164 11.5835 17.4767C11.6275 17.3772 11.616 17.2663 11.616 17.1611C11.616 16.8684 11.5701 16.5852 11.4572 16.3155C11.2162 15.7396 10.7111 15.2958 10.1085 15.1332C9.69333 15.0203 9.23607 15.0624 8.80946 15.0624C8.63727 15.0624 8.46509 15.0547 8.2929 15.0738C7.97724 15.1083 7.67115 15.2135 7.40329 15.3857C6.87719 15.7243 6.52901 16.2944 6.4716 16.9181C6.46012 17.0348 6.46203 17.1496 6.46203 17.2663C6.46203 17.3887 6.48308 17.5016 6.573 17.5915C6.66674 17.6853 6.78344 17.7025 6.90779 17.7025H9.09638C9.79659 17.7025 10.4987 17.712 11.1989 17.7025H11.2353C11.308 17.7025 11.308 17.5953 11.2372 17.5953L11.2372 17.5953Z"
      fill={fill || "white"}
    />
    <path
      d="M3.7741 7.8265C3.7741 8.48789 3.23789 9.0241 2.5765 9.0241C1.91512 9.0241 1.37891 8.48789 1.37891 7.8265C1.37891 7.16512 1.91512 6.62891 2.5765 6.62891C3.23789 6.62891 3.7741 7.16512 3.7741 7.8265Z"
      fill={fill || "white"}
    />
    <path
      d="M3.72065 7.82892C3.71491 8.30335 3.4203 8.73955 2.97069 8.90407C2.52302 9.06669 2.00839 8.92894 1.70229 8.56545C1.39237 8.19813 1.34837 7.65863 1.59516 7.24542C1.84004 6.83409 2.32979 6.61408 2.79849 6.70784C3.33226 6.81306 3.71486 7.2875 3.7206 7.82893C3.7206 7.8978 3.82965 7.8978 3.82773 7.82893C3.822 7.30856 3.49868 6.83794 3.00893 6.65428C2.51536 6.47062 1.93951 6.6275 1.60662 7.03499C1.27756 7.43866 1.23164 8.01832 1.49757 8.466C1.7654 8.91559 2.29724 9.15281 2.80998 9.05524C3.3973 8.94428 3.81818 8.41818 3.82584 7.82704C3.82967 7.76008 3.72251 7.76005 3.7206 7.82893L3.72065 7.82892Z"
      fill={fill || "white"}
    />
    <path
      d="M4.77542 11.949H0.380895C0.201063 11.949 0.0556641 11.8036 0.0556641 11.6238V11.4057C0.0556641 10.3075 0.945274 9.41797 2.04338 9.41797H3.11091C4.20905 9.41797 5.09863 10.3076 5.09863 11.4057V11.6238C5.10054 11.8017 4.95514 11.949 4.77531 11.949H4.77542Z"
      fill={fill || "white"}
    />
    <path
      d="M4.77531 11.8961H3.15491H0.755872C0.572213 11.8961 0.266115 11.9497 0.151337 11.7679C0.0939442 11.6761 0.109249 11.5575 0.109249 11.4542C0.109249 11.3279 0.114988 11.2016 0.136032 11.0773C0.187688 10.775 0.312037 10.49 0.495689 10.2451C0.859194 9.75916 1.43886 9.47412 2.04532 9.4722C2.38394 9.47028 2.72255 9.4722 3.06118 9.4722C3.61023 9.4722 4.13252 9.67308 4.51513 10.0748C4.72366 10.2929 4.87863 10.5608 4.96661 10.8516C5.03931 11.0984 5.05079 11.349 5.04697 11.6034C5.04505 11.7622 4.94175 11.8885 4.77531 11.8961C4.70644 11.898 4.70643 12.0071 4.7753 12.0033C4.92453 11.9975 5.06036 11.9172 5.12158 11.7775C5.16558 11.678 5.1541 11.5671 5.1541 11.4618C5.1541 11.1691 5.10818 10.886 4.99531 10.6162C4.75426 10.0404 4.2492 9.59657 3.64655 9.43393C3.23141 9.32106 2.77416 9.36315 2.34754 9.36315C2.17536 9.36315 2.00318 9.3555 1.83099 9.37463C1.51532 9.40907 1.20924 9.51429 0.941379 9.68647C0.415274 10.0251 0.0670917 10.5952 0.00968512 11.2189C-0.00179339 11.3356 0.000119545 11.4504 0.000119545 11.5671C0.000119545 11.6895 0.0211636 11.8024 0.111081 11.8923C0.204824 11.986 0.321523 12.0033 0.445875 12.0033H2.63446C3.33467 12.0033 4.03678 12.0128 4.73699 12.0033H4.77334C4.84412 12.0033 4.84412 11.8961 4.77525 11.8961L4.77531 11.8961Z"
      fill={fill || "white"}
    />
    <path
      d="M16.6208 7.8265C16.6208 8.48789 16.0846 9.0241 15.4232 9.0241C14.7618 9.0241 14.2256 8.48789 14.2256 7.8265C14.2256 7.16512 14.7618 6.62891 15.4232 6.62891C16.0846 6.62891 16.6208 7.16512 16.6208 7.8265Z"
      fill={fill || "white"}
    />
    <path
      d="M16.5673 7.82892C16.5616 8.30335 16.267 8.73955 15.8174 8.90407C15.3697 9.06669 14.8551 8.92894 14.549 8.56545C14.239 8.19813 14.1951 7.65863 14.4418 7.24542C14.6867 6.83409 15.1765 6.61408 15.6452 6.70784C16.177 6.81306 16.5597 7.2875 16.5673 7.82893C16.5673 7.8978 16.6763 7.8978 16.6744 7.82893C16.6687 7.30856 16.3454 6.83794 15.8556 6.65428C15.362 6.47062 14.7862 6.6275 14.4533 7.03499C14.1242 7.43866 14.0783 8.01832 14.3442 8.466C14.6121 8.91559 15.1439 9.15281 15.6567 9.05524C16.244 8.94428 16.6649 8.41818 16.6725 7.82704C16.6744 7.76008 16.5673 7.76005 16.5673 7.82893L16.5673 7.82892Z"
      fill={fill || "white"}
    />
    <path
      d="M17.62 11.949H13.2276C13.0477 11.949 12.9023 11.8036 12.9023 11.6238V11.4057C12.9023 10.3075 13.792 9.41797 14.8901 9.41797H15.9576C17.0557 9.41797 17.9453 10.3076 17.9453 11.4057V11.6238C17.9453 11.8017 17.7999 11.949 17.6201 11.949H17.62Z"
      fill={fill || "white"}
    />
    <path
      d="M17.62 11.8961H15.9996H13.6006C13.4169 11.8961 13.1108 11.9497 12.9961 11.7679C12.9387 11.6761 12.954 11.5575 12.954 11.4542C12.954 11.3279 12.9597 11.2016 12.9808 11.0773C13.0324 10.775 13.1568 10.49 13.3404 10.2451C13.7039 9.75916 14.2836 9.47412 14.89 9.4722C15.2287 9.47028 15.5673 9.4722 15.9059 9.4722C16.455 9.4722 16.9772 9.67308 17.3599 10.0748C17.5684 10.2929 17.7234 10.5608 17.8113 10.8516C17.884 11.0984 17.8955 11.349 17.8917 11.6034C17.8898 11.7622 17.7865 11.8885 17.62 11.8961C17.5512 11.898 17.5512 12.0071 17.62 12.0033C17.7693 11.9975 17.9051 11.9172 17.9663 11.7775C18.0103 11.678 17.9988 11.5671 17.9988 11.4618C17.9988 11.1691 17.9529 10.886 17.84 10.6162C17.599 10.0404 17.0939 9.59657 16.4913 9.43393C16.0761 9.32106 15.6189 9.36315 15.1923 9.36315C15.0201 9.36315 14.8479 9.3555 14.6757 9.37463C14.3601 9.40907 14.054 9.51429 13.7861 9.68647C13.26 10.0251 12.9118 10.5952 12.8544 11.2189C12.8429 11.3356 12.8448 11.4504 12.8448 11.5671C12.8448 11.6895 12.8659 11.8024 12.9558 11.8923C13.0496 11.986 13.1662 12.0033 13.2906 12.0033H15.4792C16.1794 12.0033 16.8815 12.0128 17.5817 12.0033H17.6181C17.6889 12.0033 17.6889 11.8961 17.62 11.8961L17.62 11.8961Z"
      fill={fill || "white"}
    />
    <path
      d="M5.84609 15.2643C4.76135 14.6846 3.85645 13.816 3.23659 12.7542C3.10459 12.5285 2.75257 12.7332 2.8846 12.9609C3.53888 14.08 4.49737 15.006 5.64141 15.6182C5.87289 15.7406 6.07947 15.3886 5.84609 15.2643Z"
      fill={fill || "white"}
    />
    <path
      d="M15.0084 12.634C14.4708 13.5542 13.7151 14.3405 12.8102 14.9068C12.5462 15.0732 12.2707 15.2186 11.9856 15.3468C11.8862 15.3927 11.8613 15.5381 11.9129 15.6261C11.9742 15.7294 12.0909 15.7447 12.1923 15.6988C13.2158 15.2377 14.1264 14.5261 14.817 13.6403C15.016 13.3858 15.1978 13.1199 15.3604 12.8406C15.4924 12.613 15.1403 12.4063 15.0084 12.634Z"
      fill={fill || "white"}
    />
    <path
      d="M12.0355 3.67407C13.1164 4.15043 14.0634 4.90228 14.754 5.86077C14.819 5.95068 14.9319 5.99277 15.0333 5.93346C15.1213 5.88181 15.1711 5.74407 15.106 5.65415C14.3733 4.64021 13.388 3.82522 12.2402 3.32014C12.1388 3.27614 12.0221 3.29144 11.9608 3.39284C11.9111 3.48275 11.9341 3.63007 12.0355 3.67407Z"
      fill={fill || "white"}
    />
    <path
      d="M5.75492 3.28144C4.60896 3.78652 3.62178 4.60148 2.88907 5.61545C2.82402 5.70537 2.87376 5.84311 2.96176 5.89477C3.06507 5.95407 3.17603 5.91199 3.24108 5.82207C3.93363 4.86362 4.88061 4.10984 5.95962 3.63537C6.06101 3.59137 6.08397 3.44406 6.03232 3.35606C5.97301 3.25084 5.85632 3.23744 5.75492 3.28144Z"
      fill={fill || "white"}
    />
  </svg>
);

export const CupIcon = ({ fill }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3438 1.25V8.8125C12.3438 10 11.7188 10.625 10.5313 10.625H2.90625C1.71875 10.625 1.09375 10 1.09375 8.8125V1.25H12.3438Z"
      fill={fill || "white"}
    />
    <path
      d="M12.9688 1.71875H0.46875C0.2125 1.71875 0 1.50625 0 1.25C0 0.99375 0.2125 0.78125 0.46875 0.78125H12.9688C13.225 0.78125 13.4375 0.99375 13.4375 1.25C13.4375 1.50625 13.225 1.71875 12.9688 1.71875Z"
      fill={fill || "white"}
    />
    <path
      d="M9.63792 13.9625C9.55667 14.125 9.38791 14.2188 9.21916 14.2188C9.15041 14.2188 9.07542 14.2 9.01292 14.1688L6.71916 13.025L4.4254 14.1688C4.3629 14.2 4.28791 14.2188 4.21916 14.2188C4.05041 14.2188 3.88165 14.125 3.8004 13.9625C3.68165 13.725 3.77542 13.4437 4.01292 13.3312L6.25041 12.2125V10.625H7.18791V12.2125L9.4254 13.3312C9.6629 13.4437 9.75667 13.725 9.63792 13.9625Z"
      fill={fill || "white"}
    />
    <path
      d="M3.90633 7.34285C3.77508 7.34285 3.63758 7.28661 3.54383 7.17411C3.37508 6.97411 3.40632 6.68036 3.60632 6.51161L5.57508 4.86785C5.75633 4.71785 5.98757 4.65536 6.20632 4.69286C6.43132 4.73036 6.62508 4.86784 6.74383 5.06784L7.40007 6.16159L9.23132 4.63661C9.43132 4.46786 9.72507 4.49909 9.89382 4.69909C10.0626 4.89909 10.0313 5.19284 9.83133 5.36159L7.86257 7.00534C7.68132 7.15534 7.45008 7.21784 7.23133 7.18034C7.00633 7.14284 6.81257 7.00536 6.69382 6.80536L6.03758 5.71161L4.20633 7.23659C4.11883 7.30534 4.01258 7.34285 3.90633 7.34285Z"
      fill="#37ED6A"
    />
  </svg>
);

export const LogisticGraph = ({ fill }) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0216 8.14142C17.8416 8.46056 17.6943 8.71424 17.547 8.97609C17.4488 9.14794 17.3097 9.25432 17.1133 9.13157C16.9414 9.02519 16.9578 8.86153 17.0478 8.69787C17.3097 8.23962 17.5634 7.77318 17.8252 7.31493C17.9398 7.11035 18.0953 7.06944 18.308 7.184C18.7663 7.44586 19.2327 7.70772 19.691 7.96139C19.8546 8.05141 19.9364 8.19052 19.8464 8.37055C19.7401 8.57512 19.5682 8.55057 19.3964 8.45238C19.1509 8.31326 18.8972 8.18234 18.6272 8.02686C18.6926 8.47693 18.7663 8.88608 18.8072 9.30342C19.2818 14.0496 15.9431 18.2721 11.2215 18.9185C6.83536 19.5159 2.65381 16.7418 1.53273 12.503C1.47545 12.2821 1.34452 12.0202 1.68821 11.9384C1.99916 11.8647 2.02371 12.1429 2.08099 12.3475C3.07115 15.5962 5.23148 17.5929 8.53744 18.2884C12.899 19.2049 17.3997 16.0954 18.1444 11.7011C18.3653 10.3836 18.3408 9.28705 18.0216 8.14142Z"
      fill={fill || "white"}
    />
    <path
      d="M8.97865 14.134C8.97865 15.2387 8.96228 16.3434 8.98683 17.4481C8.99501 17.7755 8.87227 17.8164 8.61041 17.7346C8.59404 17.7346 8.58586 17.7264 8.56949 17.7264C7.36658 17.4727 7.36658 17.4727 7.36658 16.2452C7.36658 14.445 7.37476 12.6447 7.3584 10.8526C7.3584 10.5744 7.41568 10.4598 7.71027 10.4844C8.11124 10.5171 8.65132 10.3534 8.89682 10.558C9.15049 10.7708 8.96228 11.3272 8.97046 11.7282C8.98683 12.5301 8.97865 13.3321 8.97865 14.134Z"
      fill={fill || "white"}
    />
    <path
      d="M1.79432 10.1289C2.07254 9.8343 2.27712 9.62154 2.48988 9.40878C2.62081 9.27785 2.75992 9.21239 2.9154 9.35968C3.08724 9.51516 3.02996 9.67882 2.89085 9.81794C2.52261 10.2025 2.14619 10.579 1.76977 10.9554C1.60611 11.119 1.43426 11.1109 1.2706 10.9472C0.894182 10.5708 0.509578 10.2025 0.133157 9.8343C0.00222801 9.70337 -0.0632367 9.55608 0.0840585 9.4006C0.239537 9.24512 0.403198 9.29422 0.550493 9.44151C0.746887 9.64609 0.943281 9.85067 1.19696 10.1207C1.2706 9.21239 1.3688 8.41045 1.60611 7.63306C2.98905 3.08327 7.77614 0.423773 12.3505 1.68397C12.3914 1.69215 12.4241 1.7167 12.465 1.72488C12.6696 1.7658 12.866 1.84763 12.8087 2.08494C12.7514 2.34679 12.5469 2.33861 12.3177 2.27315C11.6795 2.08494 11.0166 1.99492 10.3456 1.96219C5.86949 1.7658 1.9989 5.30906 1.79432 9.7852C1.79432 9.85067 1.79432 9.9325 1.79432 10.1289Z"
      fill={fill || "white"}
    />
    <path
      d="M14.4779 16.3649C14.4779 14.221 14.4779 12.1016 14.4697 9.98215C14.4697 9.75303 14.5352 9.66301 14.7643 9.67938C15.1898 9.72029 15.7545 9.49935 16.0163 9.76939C16.2209 9.98215 16.0818 10.5386 16.0818 10.9478C16.0818 12.1425 16.0736 13.3454 16.09 14.5401C16.09 14.8183 16.0163 15.0311 15.8281 15.2275C15.509 15.5712 15.1817 15.8903 14.8216 16.1849C14.7316 16.2667 14.6416 16.3813 14.4779 16.3649Z"
      fill={fill || "white"}
    />
    <path
      d="M4.74804 10.3108C4.89534 10.3763 5.01808 10.2945 5.14901 10.2126C5.86912 9.72165 6.58923 9.23066 7.30934 8.74786C7.44845 8.64967 7.55483 8.55965 7.57938 8.37144C7.6203 8.07685 7.83306 7.92137 8.11128 7.88864C8.39769 7.85591 8.635 7.97865 8.7332 8.25688C8.80684 8.46146 8.94596 8.55147 9.12598 8.62512C9.63333 8.85424 10.1489 9.067 10.6399 9.32068C11.3681 9.6971 12.031 9.648 12.6856 9.14883C13.1275 8.81333 13.6103 8.52692 14.0686 8.20778C14.355 8.01139 14.6496 7.86409 14.7641 7.46312C14.8459 7.17671 15.1569 7.06215 15.476 7.17671C15.787 7.28309 15.9425 7.5204 15.8934 7.83954C15.8443 8.17505 15.6233 8.42054 15.2797 8.35508C14.9523 8.29779 14.7396 8.43691 14.5023 8.60057C13.9704 8.96062 13.4385 9.31249 12.9066 9.67255C12.6365 9.86076 12.3174 9.98351 12.2601 10.3927C12.2274 10.6054 11.9982 10.72 11.7527 10.7363C11.4991 10.7445 11.2699 10.6463 11.1881 10.4172C11.0981 10.1472 10.8935 10.0572 10.6726 9.95896C10.198 9.7462 9.72335 9.55799 9.2651 9.31249C8.5368 8.92789 7.88216 8.98517 7.21933 9.48434C6.6547 9.90986 6.04915 10.2863 5.46815 10.6872C5.34541 10.7691 5.23903 10.8427 5.20629 11.0228C5.13265 11.3992 4.82987 11.6038 4.50255 11.5383C4.18341 11.4728 3.9461 11.1701 3.98702 10.8509C4.0443 10.4909 4.33071 10.2863 4.74804 10.3108Z"
      fill={fill || "white"}
    />
    <path
      d="M10.9345 14.8854C10.9345 14.018 10.9427 13.1424 10.9263 12.275C10.9181 11.9967 11.0082 11.9313 11.27 11.9477C11.5973 11.9722 11.9247 11.964 12.252 11.9477C12.4566 11.9395 12.5384 11.9804 12.5302 12.2095C12.522 13.8707 12.522 15.5318 12.5302 17.193C12.5302 17.3812 12.4893 17.4958 12.2765 17.5367C11.9329 17.6022 11.5892 17.684 11.2455 17.774C11 17.8395 10.9181 17.774 10.9263 17.504C10.9427 16.6284 10.9345 15.7528 10.9345 14.8854Z"
      fill={fill || "white"}
    />
    <path
      d="M5.41955 16.3022C4.79763 15.8439 4.32302 15.3448 3.90568 14.7965C3.7993 14.6574 3.83203 14.5101 3.83203 14.371C3.82385 13.9209 3.84022 13.4709 3.82385 13.0208C3.81567 12.7998 3.88931 12.7426 4.10207 12.7507C4.47031 12.7671 4.83855 12.7589 5.20679 12.7589C5.31317 12.7589 5.42773 12.7426 5.42773 12.9144C5.41955 14.0191 5.41955 15.132 5.41955 16.3022Z"
      fill={fill || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9276 3.18321C19.9276 1.43204 18.4874 0 16.728 0C14.9523 0 13.5366 1.40749 13.5285 3.17503C13.5121 4.95076 14.9605 6.39916 16.7362 6.39098C18.4874 6.38279 19.9276 4.93439 19.9276 3.18321ZM19.2731 3.17503C19.2567 1.77572 18.1193 0.654641 16.7118 0.654641C15.3043 0.654641 14.175 1.7839 14.175 3.19958C14.175 4.61525 15.3288 5.75269 16.7527 5.74451C18.1356 5.72814 19.2895 4.55796 19.2731 3.17503Z"
      fill={fill || "white"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7005 3.19874C18.7005 2.11039 17.8167 1.2348 16.7202 1.22662C15.6236 1.21844 14.748 2.09402 14.748 3.19056C14.748 4.2789 15.6318 5.17086 16.7202 5.17086C17.8003 5.17086 18.7005 4.2789 18.7005 3.19874ZM17.0968 2.50329C17.3177 2.66695 17.5632 2.56875 17.5714 2.32326C17.5796 2.18415 17.5059 2.09413 17.4159 2.0123C17.3773 1.98379 17.3381 1.95768 17.2992 1.93187C17.1486 1.83174 17.0047 1.73601 16.9331 1.52132C16.8594 1.30856 16.5403 1.34948 16.4667 1.58678C16.4176 1.75045 16.3276 1.82409 16.2048 1.90592C15.902 2.10232 15.7384 2.38054 15.8038 2.7406C15.8775 3.1252 16.123 3.36251 16.5076 3.45252C16.5608 3.4648 16.614 3.47298 16.6671 3.48116C16.7203 3.48935 16.7735 3.49753 16.8267 3.50981C16.9822 3.54254 17.1049 3.63255 17.0722 3.82076C17.0395 4.00079 16.8922 4.04989 16.7367 4.06625C16.6303 4.07444 16.5321 4.02534 16.4421 3.95169C16.2703 3.82076 16.0902 3.74711 15.9511 3.95987C15.812 4.17263 15.9675 4.31993 16.1312 4.43449C16.1365 4.43815 16.1418 4.4418 16.1472 4.44542C16.2961 4.5472 16.4286 4.63765 16.5076 4.82728C16.5976 5.04822 16.8922 5.03186 16.974 4.80273C17.0313 4.63907 17.1131 4.56542 17.2441 4.48359C17.5632 4.2872 17.7187 3.98442 17.6368 3.61619C17.5632 3.24795 17.3177 3.027 16.9495 2.94517C16.8963 2.9329 16.8431 2.92472 16.7899 2.91653C16.7367 2.90835 16.6835 2.90017 16.6303 2.88789C16.483 2.86334 16.3685 2.77333 16.3685 2.61785C16.3685 2.43782 16.5076 2.36418 16.6631 2.33144C16.8172 2.30207 16.9319 2.3847 17.0543 2.47293C17.0684 2.48303 17.0825 2.4932 17.0968 2.50329Z"
      fill={fill || "white"}
    />
  </svg>
);

export const MenuDropDownIcon = () => (
  <svg
    width="4"
    height="20"
    viewBox="0 0 4 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.76473" cy="1.76473" r="1.76473" fill="black" />
    <circle cx="1.76473" cy="9.99911" r="1.76473" fill="black" />
    <circle cx="1.76473" cy="18.2335" r="1.76473" fill="black" />
  </svg>
);

export const UploadFileIcon = () => (
  <svg
    width="25"
    height="19"
    viewBox="0 0 25 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8359 6.33594C12.1875 5.98438 12.7734 5.98438 13.125 6.33594L16.25 9.46094C16.6406 9.85156 16.6406 10.4375 16.25 10.7891C15.8984 11.1797 15.3125 11.1797 14.9609 10.7891L13.4375 9.26562V14.5C13.4375 15.0469 13.0078 15.4375 12.5 15.4375C11.9531 15.4375 11.5625 15.0469 11.5625 14.5V9.26562L10 10.7891C9.64844 11.1797 9.0625 11.1797 8.71094 10.7891C8.32031 10.4375 8.32031 9.85156 8.71094 9.46094L11.8359 6.33594ZM5.625 18.25C2.5 18.25 0 15.75 0 12.625C0 10.2031 1.5625 8.09375 3.75 7.35156V7.3125C3.75 3.71875 6.67969 0.75 10.3125 0.75C12.2656 0.75 14.0625 1.64844 15.2734 3.05469C15.8594 2.78125 16.4844 2.625 17.1875 2.625C19.7656 2.625 21.875 4.73438 21.875 7.3125C21.875 7.58594 21.8359 7.82031 21.7969 8.09375C23.6719 8.91406 25 10.7891 25 12.9375C25 15.7891 22.7734 18.0938 20 18.25H5.625ZM10.3125 2.625C7.69531 2.625 5.625 4.73438 5.625 7.3125V8.67969L4.33594 9.10938C2.89062 9.61719 1.875 11.0234 1.875 12.625C1.875 14.6953 3.51562 16.375 5.625 16.375H19.7656H19.8828C21.6797 16.2969 23.125 14.7734 23.125 12.9375C23.125 11.5312 22.2656 10.3203 21.0547 9.8125L19.7266 9.22656L19.9609 7.78125C19.9609 7.625 20 7.46875 20 7.3125C20 5.78906 18.7109 4.5 17.1875 4.5C16.7578 4.5 16.3672 4.61719 16.0156 4.77344L14.7656 5.32031L13.8281 4.26562C12.9688 3.28906 11.7188 2.625 10.2734 2.625H10.3125Z"
      fill="#253CA5"
    />
  </svg>
);

export const ListingIcon = () => (
  <svg
    width="8"
    height="17"
    viewBox="0 0 8 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1.5" cy="1.5" r="1.5" fill="#8F8F8F" />
    <circle cx="6.5" cy="1.5" r="1.5" fill="#8F8F8F" />
    <circle cx="6.5" cy="8.5" r="1.5" fill="#8F8F8F" />
    <circle cx="1.5" cy="8.5" r="1.5" fill="#8F8F8F" />
    <circle cx="1.5" cy="15.5" r="1.5" fill="#8F8F8F" />
    <circle cx="6.5" cy="15.5" r="1.5" fill="#8F8F8F" />
  </svg>
);

export const ValidInfo = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.98288 4.47422L8.42038 3.81589C8.31621 3.69089 8.22871 3.45755 8.22871 3.29089V2.58255C8.22871 2.14089 7.86621 1.77839 7.42454 1.77839H6.71621C6.54954 1.77839 6.31204 1.69089 6.18704 1.58672L5.52871 1.02422C5.24121 0.778385 4.77038 0.778385 4.48288 1.02422L3.81621 1.58672C3.69121 1.69089 3.45788 1.77839 3.29121 1.77839H2.57038C2.12871 1.77839 1.76621 2.14089 1.76621 2.58255V3.29089C1.76621 3.45339 1.68288 3.68672 1.57871 3.81172L1.01621 4.47422C0.774544 4.76589 0.774544 5.23255 1.01621 5.51589L1.57871 6.17839C1.68288 6.29922 1.76621 6.53672 1.76621 6.69922V7.41172C1.76621 7.85339 2.12871 8.21588 2.57038 8.21588H3.29538C3.45788 8.21588 3.69538 8.30339 3.82038 8.40755L4.47871 8.97005C4.76621 9.21589 5.23704 9.21589 5.52454 8.97005L6.18288 8.40755C6.30788 8.30339 6.54121 8.21588 6.70788 8.21588H7.41621C7.85788 8.21588 8.22038 7.85339 8.22038 7.41172V6.70339C8.22038 6.53672 8.30788 6.30339 8.41204 6.17839L8.97454 5.52005C9.22871 5.23672 9.22871 4.76589 8.98288 4.47422ZM4.68704 3.38672C4.68704 3.21589 4.82871 3.07422 4.99954 3.07422C5.17038 3.07422 5.31204 3.21589 5.31204 3.38672V5.39922C5.31204 5.57005 5.17038 5.71172 4.99954 5.71172C4.82871 5.71172 4.68704 5.57005 4.68704 5.39922V3.38672ZM4.99954 7.02839C4.77038 7.02839 4.58288 6.84089 4.58288 6.61172C4.58288 6.38255 4.76621 6.19505 4.99954 6.19505C5.22871 6.19505 5.41621 6.38255 5.41621 6.61172C5.41621 6.84089 5.23288 7.02839 4.99954 7.02839Z"
      fill="#7B7F91"
    />
  </svg>
);

export const DownLoadIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.08008 6.58203C6.33034 6.58203 6.5332 6.37917 6.5332 6.12891V0.578125C6.5332 0.327864 6.33034 0.125 6.08008 0.125C5.82982 0.125 5.62695 0.327864 5.62695 0.578125V6.12891C5.62695 6.37917 5.82982 6.58203 6.08008 6.58203Z"
      fill="white"
    />
    <path
      d="M5.09156 8.44564C5.09233 8.44641 5.09308 8.44718 5.09385 8.44795C5.35895 8.71305 5.70713 8.84555 6.05532 8.84555C6.40322 8.84555 6.75109 8.71319 7.01567 8.44859L9.52408 5.94997C9.70139 5.77336 9.70195 5.48646 9.52535 5.30916C9.34874 5.13187 9.06184 5.13128 8.88454 5.30789L6.37549 7.80714C6.2899 7.89272 6.17612 7.93986 6.05509 7.93986C5.93449 7.93986 5.82107 7.89308 5.73559 7.80807L3.27388 5.31081C3.0982 5.13257 2.81128 5.13053 2.63307 5.30621C2.45485 5.48189 2.45279 5.76878 2.62847 5.94702L5.09156 8.44564Z"
      fill="white"
    />
    <path
      d="M11.4262 9.46094C11.1759 9.46094 10.973 9.6638 10.973 9.91406C10.973 10.4138 10.5665 10.8203 10.0668 10.8203H2.0918C1.59209 10.8203 1.18555 10.4138 1.18555 9.91406C1.18555 9.6638 0.982683 9.46094 0.732422 9.46094C0.482161 9.46094 0.279297 9.6638 0.279297 9.91406C0.279297 10.9135 1.09238 11.7266 2.0918 11.7266H10.0668C11.0662 11.7266 11.8793 10.9135 11.8793 9.91406C11.8793 9.6638 11.6764 9.46094 11.4262 9.46094Z"
      fill="white"
    />
  </svg>
);

export const DeleteIcon = ({ fill }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0768 4.58863C14.9095 4.47263 13.7423 4.38563 12.5678 4.32038V4.31313L12.4083 3.37063C12.2995 2.70363 12.14 1.70312 10.4435 1.70312H8.54403C6.85478 1.70312 6.69528 2.66013 6.57928 3.36338L6.42703 4.29138C5.75278 4.33488 5.07853 4.37838 4.40428 4.44363L2.92528 4.58863C2.62078 4.61763 2.40328 4.88588 2.43228 5.18313C2.46128 5.48038 2.72228 5.69788 3.02678 5.66888L4.50578 5.52388C8.30478 5.14688 12.1328 5.29188 15.9753 5.67613C15.997 5.67613 16.0115 5.67613 16.0333 5.67613C16.3088 5.67613 16.548 5.46588 16.577 5.18313C16.5988 4.88588 16.3813 4.61763 16.0768 4.58863Z"
      fill={fill || "white"}
    />
    <path
      d="M14.7432 6.69681C14.5692 6.51556 14.3299 6.41406 14.0834 6.41406H4.91943C4.67293 6.41406 4.42643 6.51556 4.25968 6.69681C4.09293 6.87806 3.99868 7.12456 4.01318 7.37831L4.46268 14.8168C4.54243 15.9188 4.64393 17.2963 7.17418 17.2963H11.8287C14.3589 17.2963 14.4604 15.9261 14.5402 14.8168L14.9897 7.38556C15.0042 7.12456 14.9099 6.87806 14.7432 6.69681ZM10.7049 13.6641H8.29068C7.99343 13.6641 7.74693 13.4176 7.74693 13.1203C7.74693 12.8231 7.99343 12.5766 8.29068 12.5766H10.7049C11.0022 12.5766 11.2487 12.8231 11.2487 13.1203C11.2487 13.4176 11.0022 13.6641 10.7049 13.6641ZM11.3139 10.7641H7.68893C7.39168 10.7641 7.14518 10.5176 7.14518 10.2203C7.14518 9.92306 7.39168 9.67656 7.68893 9.67656H11.3139C11.6112 9.67656 11.8577 9.92306 11.8577 10.2203C11.8577 10.5176 11.6112 10.7641 11.3139 10.7641Z"
      fill={fill || "white"}
    />
  </svg>
);

export const ForwordIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3887_3474)">
      <path
        d="M10.5 0H6.49998C6.22384 0 5.99997 0.223867 5.99997 0.500006C5.99997 0.776145 6.22384 1.00001 6.49998 1.00001H9.29288L4.14645 6.14646C3.95118 6.34174 3.95118 6.65829 4.14645 6.85356C4.24406 6.95118 4.37202 7 4.49998 7C4.62794 7 4.75592 6.95121 4.85355 6.85354L10 1.70711V4.50001C10 4.77615 10.2239 5.00002 10.5 5.00002C10.7761 5.00002 11 4.77615 11 4.50001V0.500006C11 0.223867 10.7761 0 10.5 0Z"
        fill="white"
      />
      <path
        d="M8.49999 4.99999C8.22385 4.99999 7.99999 5.22386 7.99999 5.5V10H0.99999V2.99999H5.5C5.77614 2.99999 6.00001 2.77612 6.00001 2.49998C6.00001 2.22385 5.77614 2 5.5 2H0.500006C0.223867 2 0 2.22387 0 2.50001V10.5C0 10.7761 0.223867 11 0.500006 11H8.50001C8.77615 11 9.00002 10.7761 9.00002 10.5V5.5C9 5.22386 8.77613 4.99999 8.49999 4.99999Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3887_3474">
        <rect width="11" height="11" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DeleteAttach = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12.5C5 12.7812 4.75 13 4.5 13C4.21875 13 4 12.7812 4 12.5V6C4 5.75 4.21875 5.5 4.5 5.5C4.75 5.5 5 5.75 5 6V12.5ZM7.5 12.5C7.5 12.7812 7.25 13 7 13C6.71875 13 6.5 12.7812 6.5 12.5V6C6.5 5.75 6.71875 5.5 7 5.5C7.25 5.5 7.5 5.75 7.5 6V12.5ZM10 12.5C10 12.7812 9.75 13 9.5 13C9.21875 13 9 12.7812 9 12.5V6C9 5.75 9.21875 5.5 9.5 5.5C9.75 5.5 10 5.75 10 6V12.5ZM9.90625 0.78125L11.0625 2.5H13.25C13.6562 2.5 14 2.84375 14 3.25C14 3.6875 13.6562 4 13.25 4H13V13.5C13 14.9062 11.875 16 10.5 16H3.5C2.09375 16 1 14.9062 1 13.5V4H0.75C0.3125 4 0 3.6875 0 3.25C0 2.84375 0.3125 2.5 0.75 2.5H2.90625L4.0625 0.78125C4.375 0.3125 4.9375 0 5.53125 0H8.4375C9.03125 0 9.59375 0.3125 9.90625 0.78125ZM4.71875 2.5H9.25L8.65625 1.625C8.625 1.5625 8.53125 1.5 8.4375 1.5H5.53125C5.4375 1.5 5.34375 1.5625 5.3125 1.625L4.71875 2.5ZM2.5 13.5C2.5 14.0625 2.9375 14.5 3.5 14.5H10.5C11.0312 14.5 11.5 14.0625 11.5 13.5V4H2.5V13.5Z"
      fill="#ED9A8F"
    />
  </svg>
);
export const CalenderIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="14" height="14" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_3712_14471" transform="scale(0.00666667)" />
      </pattern>
      <image
        id="image0_3712_14471"
        width="150"
        height="150"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const UserImage = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M48 95.5469C74.2335 95.5469 95.5 74.2804 95.5 48.0469C95.5 21.8133 74.2335 0.546875 48 0.546875C21.7665 0.546875 0.5 21.8133 0.5 48.0469C0.5 74.2804 21.7665 95.5469 48 95.5469Z"
      fill="#7B7F91"
    />
    <path
      d="M48 23.9648C38.1675 23.9648 30.1875 31.9448 30.1875 41.7773C30.1875 51.4198 37.74 59.2573 47.7625 59.5423C47.905 59.5423 48.095 59.5423 48.19 59.5423C48.285 59.5423 48.4275 59.5423 48.5225 59.5423C48.57 59.5423 48.6175 59.5423 48.6175 59.5423C58.2125 59.2098 65.765 51.4198 65.8125 41.7773C65.8125 31.9448 57.8325 23.9648 48 23.9648Z"
      fill="#292D32"
    />
    <path
      d="M80.2049 82.9606C71.7499 90.7506 60.4449 95.5481 47.9999 95.5481C35.5549 95.5481 24.2499 90.7506 15.7949 82.9606C16.9349 78.6381 20.0224 74.6956 24.5349 71.6556C37.5024 63.0106 58.5924 63.0106 71.4649 71.6556C76.0249 74.6956 79.0649 78.6381 80.2049 82.9606Z"
      fill="#292D32"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M10.3207 2H5.01398C2.71398 2 1.33398 3.37333 1.33398 5.68V10.98C1.33398 13.2933 2.71398 14.6667 5.01398 14.6667H10.314C12.6207 14.6667 13.994 13.2933 13.994 10.9867V5.68C14.0007 3.37333 12.6207 2 10.3207 2Z"
      fill="white"
    />
    <path
      d="M14.013 1.98815C12.8197 0.788153 11.653 0.761486 10.4263 1.98815L9.67299 2.73482C9.60632 2.80149 9.58632 2.89482 9.61299 2.98149C10.0797 4.61482 11.3863 5.92149 13.0197 6.38815C13.0397 6.39482 13.073 6.39482 13.093 6.39482C13.1597 6.39482 13.2263 6.36815 13.273 6.32149L14.013 5.57482C14.6197 4.96815 14.9197 4.38815 14.9197 3.79482C14.9197 3.19482 14.6197 2.60149 14.013 1.98815Z"
      fill="white"
    />
    <path
      d="M11.9061 6.94526C11.7261 6.85859 11.5527 6.77193 11.3927 6.67193C11.2594 6.59193 11.1261 6.50526 10.9994 6.41193C10.8927 6.34526 10.7727 6.24526 10.6527 6.14526C10.6394 6.13859 10.5994 6.10526 10.5461 6.05193C10.3394 5.88526 10.1194 5.65859 9.91275 5.41193C9.89942 5.39859 9.85942 5.35859 9.82608 5.29859C9.75942 5.22526 9.65942 5.09859 9.57275 4.95859C9.49942 4.86526 9.41275 4.73193 9.33275 4.59193C9.23275 4.42526 9.14608 4.25859 9.06608 4.08526C8.97942 3.89859 8.91275 3.72526 8.85275 3.55859L5.26608 7.14526C5.03275 7.37859 4.80608 7.81859 4.75942 8.14526L4.47275 10.1319C4.41275 10.5519 4.52608 10.9453 4.78608 11.2053C5.00608 11.4253 5.30608 11.5386 5.63942 11.5386C5.71275 11.5386 5.78608 11.5319 5.85942 11.5253L7.83942 11.2453C8.16608 11.1986 8.60608 10.9786 8.83942 10.7386L12.4261 7.15193C12.2594 7.09859 12.0927 7.02526 11.9061 6.94526Z"
      fill="white"
    />
  </svg>
);

export const UpArrow = () => (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 0L10.2631 8.25H0.73686L5.5 0Z" fill="black" />
  </svg>
);
export const UserFilled = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
      fill="#7B7F91"
    />
    <path
      d="M14.0809 14.1509C11.2909 12.2909 6.74094 12.2909 3.93094 14.1509C2.66094 15.0009 1.96094 16.1509 1.96094 17.3809C1.96094 18.6109 2.66094 19.7509 3.92094 20.5909C5.32094 21.5309 7.16094 22.0009 9.00094 22.0009C10.8409 22.0009 12.6809 21.5309 14.0809 20.5909C15.3409 19.7409 16.0409 18.6009 16.0409 17.3609C16.0309 16.1309 15.3409 14.9909 14.0809 14.1509Z"
      fill="#7B7F91"
    />
    <path
      opacity="0.4"
      d="M19.9894 7.3401C20.1494 9.2801 18.7694 10.9801 16.8594 11.2101C16.8494 11.2101 16.8494 11.2101 16.8394 11.2101H16.8094C16.7494 11.2101 16.6894 11.2101 16.6394 11.2301C15.6694 11.2801 14.7794 10.9701 14.1094 10.4001C15.1394 9.4801 15.7294 8.1001 15.6094 6.6001C15.5394 5.7901 15.2594 5.0501 14.8394 4.4201C15.2194 4.2301 15.6594 4.1101 16.1094 4.0701C18.0694 3.9001 19.8194 5.3601 19.9894 7.3401Z"
      fill="#7B7F91"
    />
    <path
      d="M21.9902 16.5904C21.9102 17.5604 21.2902 18.4004 20.2502 18.9704C19.2502 19.5204 17.9902 19.7804 16.7402 19.7504C17.4602 19.1004 17.8802 18.2904 17.9602 17.4304C18.0602 16.1904 17.4702 15.0004 16.2902 14.0504C15.6202 13.5204 14.8402 13.1004 13.9902 12.7904C16.2002 12.1504 18.9802 12.5804 20.6902 13.9604C21.6102 14.7004 22.0802 15.6304 21.9902 16.5904Z"
      fill="#7B7F91"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.5 9L10.2631 0.75H0.73686L5.5 9Z" fill="black" />
  </svg>
);
export const ViewIcon = () => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0047 14C6.43738 14 3.06926 12.2927 0.754269 9.32816C-0.251423 8.04767 -0.251423 5.96009 0.754269 4.67184C3.07875 1.70732 6.44687 0 10.0047 0C13.5626 0 16.9307 1.70732 19.2457 4.67184C20.2514 5.95233 20.2514 8.03991 19.2457 9.32816C16.9307 12.2927 13.5626 14 10.0047 14Z"
      fill="#FF483C"
    />
    <path
      d="M9.99945 10.247C8.20695 10.247 6.75195 8.79195 6.75195 6.99945C6.75195 5.20695 8.20695 3.75195 9.99945 3.75195C11.792 3.75195 13.247 5.20695 13.247 6.99945C13.247 8.79195 11.792 10.247 9.99945 10.247ZM9.99945 4.87695C8.82945 4.87695 7.87695 5.82945 7.87695 6.99945C7.87695 8.16945 8.82945 9.12195 9.99945 9.12195C11.1695 9.12195 12.122 8.16945 12.122 6.99945C12.122 5.82945 11.1695 4.87695 9.99945 4.87695Z"
      fill="white"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M15 7.2V16.79C15 20 13 22 9.8 22H7.21C4.01 22 2.01 20 2.01 16.8V7.2C2 4 4 2 7.2 2H9.8C13 2 15 4 15 7.2Z"
      fill="#7B7F91"
    />
    <path
      d="M18.4305 8.11953L21.7805 11.4695C22.0705 11.7595 22.0705 12.2395 21.7805 12.5295L18.4305 15.8795C18.1405 16.1695 17.6605 16.1695 17.3705 15.8795C17.0805 15.5895 17.0805 15.1095 17.3705 14.8195L19.4405 12.7495H8.75055C8.34055 12.7495 8.00055 12.4095 8.00055 11.9995C8.00055 11.5895 8.34055 11.2495 8.75055 11.2495H19.4405L17.3705 9.17953C17.2205 9.02953 17.1505 8.83953 17.1505 8.64953C17.1505 8.45953 17.2205 8.25953 17.3705 8.11953C17.6605 7.81953 18.1305 7.81953 18.4305 8.11953Z"
      fill="#7B7F91"
    />
  </svg>
);

export const ChangePasswordIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.75 8V10.1C18.31 10.04 17.81 10.01 17.25 10V8C17.25 4.85 16.36 2.75 12 2.75C7.64 2.75 6.75 4.85 6.75 8V10C6.19 10.01 5.69 10.04 5.25 10.1V8C5.25 5.1 5.95 1.25 12 1.25C18.05 1.25 18.75 5.1 18.75 8Z"
      fill="#7B7F91"
    />
    <path
      opacity="0.4"
      d="M22 15V17C22 21 21 22 17 22H7C3 22 2 21 2 17V15C2 11.66 2.7 10.41 5.25 10.1C5.69 10.04 6.19 10.01 6.75 10H17.25C17.81 10.01 18.31 10.04 18.75 10.1C21.3 10.41 22 11.66 22 15Z"
      fill="#7B7F91"
    />
    <path
      d="M8 17.0008C7.87 17.0008 7.74 16.9708 7.62 16.9208C7.49 16.8708 7.39001 16.8008 7.29001 16.7108C7.11001 16.5208 7 16.2608 7 16.0008C7 15.8708 7.02999 15.7408 7.07999 15.6208C7.12999 15.5008 7.20001 15.3908 7.29001 15.2908C7.39001 15.2008 7.49 15.1308 7.62 15.0808C7.99 14.9208 8.42999 15.0108 8.70999 15.2908C8.79999 15.3908 8.87001 15.5008 8.92001 15.6208C8.97001 15.7408 9 15.8708 9 16.0008C9 16.2608 8.88999 16.5208 8.70999 16.7108C8.51999 16.8908 8.26 17.0008 8 17.0008Z"
      fill="#7B7F91"
    />
    <path
      d="M12 16.9992C11.73 16.9992 11.48 16.8892 11.29 16.7092C11.2 16.6092 11.13 16.4992 11.08 16.3792C11.03 16.2592 11 16.1292 11 15.9992C11 15.7292 11.11 15.4792 11.29 15.2892C11.66 14.9192 12.33 14.9192 12.71 15.2892C12.89 15.4792 13 15.7292 13 15.9992C13 16.1292 12.97 16.2592 12.92 16.3792C12.87 16.4992 12.8 16.6092 12.71 16.7092C12.52 16.8892 12.26 16.9992 12 16.9992Z"
      fill="#7B7F91"
    />
    <path
      d="M16 16.9992C15.74 16.9992 15.48 16.8892 15.29 16.7092C15.11 16.5192 15 16.2692 15 15.9992C15 15.7292 15.11 15.4792 15.29 15.2892C15.67 14.9192 16.34 14.9192 16.71 15.2892C16.75 15.3392 16.79 15.3892 16.83 15.4492C16.87 15.4992 16.9 15.5592 16.92 15.6192C16.95 15.6792 16.97 15.7392 16.98 15.7992C16.99 15.8692 17 15.9392 17 15.9992C17 16.2592 16.89 16.5192 16.71 16.7092C16.52 16.8892 16.26 16.9992 16 16.9992Z"
      fill="#7B7F91"
    />
  </svg>
);

export const RightArrow = () => (
  <svg
    width="7"
    height="13"
    viewBox="0 0 7 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.56875 11.918C1.45 11.918 1.33125 11.8742 1.2375 11.7805C1.05625 11.5992 1.05625 11.2992 1.2375 11.118L5.3125 7.04297C5.6125 6.74297 5.6125 6.25547 5.3125 5.95547L1.2375 1.88047C1.05625 1.69922 1.05625 1.39922 1.2375 1.21797C1.41875 1.03672 1.71875 1.03672 1.9 1.21797L5.975 5.29297C6.29375 5.61172 6.475 6.04297 6.475 6.49922C6.475 6.95547 6.3 7.38672 5.975 7.70547L1.9 11.7805C1.80625 11.868 1.6875 11.918 1.56875 11.918Z"
      fill="#292D32"
      stroke="black"
    />
  </svg>
);

export const VerifyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.0793 6.57757L13.5991 6.09757C13.4124 5.9109 13.3057 5.65757 13.3057 5.39157V4.70424C13.3057 3.59757 12.4054 2.69824 11.2983 2.69824H10.6114C10.3446 2.69824 10.0912 2.5909 9.90446 2.40424L9.41761 1.91824C8.63066 1.13824 7.35687 1.13824 6.57659 1.92424L6.09641 2.40424C5.90968 2.5909 5.65625 2.69824 5.38949 2.69824H4.70257C3.5955 2.69824 2.69518 3.59757 2.69518 4.70424V5.38424C2.69518 5.65757 2.58847 5.9109 2.40174 6.09757L1.9149 6.5849C1.13461 7.3709 1.14128 8.6449 1.92157 9.42424L2.40174 9.89757C2.58847 10.0909 2.69518 10.3442 2.69518 10.6116V11.2976C2.69518 12.4042 3.5955 13.3049 4.70257 13.3049H5.38949C5.65625 13.3049 5.90968 13.4109 6.09641 13.5976L6.58325 14.0849C6.97673 14.4716 7.49025 14.6642 8.00377 14.6642C8.51729 14.6642 9.03081 14.4716 9.42428 14.0776L9.90446 13.5976C10.0912 13.4109 10.3446 13.3049 10.6114 13.3049H11.2983C12.4054 13.3049 13.3057 12.4042 13.3057 11.2976V10.6116C13.3057 10.3442 13.4124 10.0909 13.5991 9.90424L14.0726 9.4309C14.0793 9.42424 14.086 9.41824 14.0926 9.4109C14.4661 9.03157 14.6729 8.52424 14.6662 7.9909C14.6662 7.45757 14.4594 6.9509 14.0793 6.57757Z"
      fill="#03B129"
    />
    <path
      d="M10.7433 6.99667L7.57667 10.1633C7.46333 10.2767 7.31667 10.33 7.16333 10.33C7.01667 10.33 6.87 10.2767 6.75667 10.1633L5.17 8.58333C4.94333 8.35 4.94333 7.98333 5.17 7.75667C5.39667 7.53 5.77 7.53 5.99667 7.75667L7.16333 8.92333L9.91667 6.17C10.1433 5.94333 10.5167 5.94333 10.7433 6.17C10.97 6.40333 10.97 6.77 10.7433 6.99667Z"
      fill="white"
    />
  </svg>
);

export const ReportUser = ({ fill }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M21.0902 21.5C21.0902 21.78 20.8702 22 20.5902 22H3.41016C3.13016 22 2.91016 21.78 2.91016 21.5C2.91016 17.36 6.99018 14 12.0002 14C13.0302 14 14.0302 14.14 14.9502 14.41C14.3602 15.11 14.0002 16.02 14.0002 17C14.0002 17.75 14.2102 18.46 14.5802 19.06C14.7802 19.4 15.0402 19.71 15.3402 19.97C16.0402 20.61 16.9702 21 18.0002 21C19.1202 21 20.1302 20.54 20.8502 19.8C21.0102 20.34 21.0902 20.91 21.0902 21.5Z"
      fill={fill || "#7B7F91"}
    />
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      fill={fill || "#7B7F91"}
    />
    <path
      d="M18.0007 21.1673C20.3018 21.1673 22.1673 19.3018 22.1673 17.0007C22.1673 14.6995 20.3018 12.834 18.0007 12.834C15.6995 12.834 13.834 14.6995 13.834 17.0007C13.834 19.3018 15.6995 21.1673 18.0007 21.1673Z"
      fill={fill || "#7B7F91"}
    />
    <path
      d="M18 15.0202C18.1708 15.0202 18.3125 15.1618 18.3125 15.3327V17.416C18.3125 17.5868 18.1708 17.7285 18 17.7285C17.8292 17.7285 17.6875 17.5868 17.6875 17.416V15.3327C17.6875 15.1618 17.8292 15.0202 18 15.0202Z"
      fill="white"
    />
    <path
      d="M18.384 19.3043C18.3632 19.3543 18.334 19.4001 18.2965 19.4418C18.2548 19.4793 18.209 19.5085 18.159 19.5293C18.059 19.571 17.9423 19.571 17.8423 19.5293C17.7923 19.5085 17.7465 19.4793 17.7048 19.4418C17.6673 19.4001 17.6382 19.3543 17.6173 19.3043C17.5965 19.2543 17.584 19.2001 17.584 19.146C17.584 19.0918 17.5965 19.0376 17.6173 18.9876C17.6382 18.9335 17.6673 18.8918 17.7048 18.8501C17.7465 18.8126 17.7923 18.7835 17.8423 18.7626C17.8923 18.7418 17.9465 18.7293 18.0007 18.7293C18.0548 18.7293 18.109 18.7418 18.159 18.7626C18.209 18.7835 18.2548 18.8126 18.2965 18.8501C18.334 18.8918 18.3632 18.9335 18.384 18.9876C18.4048 19.0376 18.4173 19.0918 18.4173 19.146C18.4173 19.2001 18.4048 19.2543 18.384 19.3043Z"
      fill="white"
    />
  </svg>
);

export const BlockUser = ({ fill }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M14.9 2H9.10001C8.42001 2 7.46 2.4 6.98 2.88L2.88 6.98001C2.4 7.46001 2 8.42001 2 9.10001V14.9C2 15.58 2.4 16.54 2.88 17.02L6.98 21.12C7.46 21.6 8.42001 22 9.10001 22H14.9C15.58 22 16.54 21.6 17.02 21.12L21.12 17.02C21.6 16.54 22 15.58 22 14.9V9.10001C22 8.42001 21.6 7.46001 21.12 6.98001L17.02 2.88C16.54 2.4 15.58 2 14.9 2Z"
      fill={fill || "#A8580F"}
    />
    <path
      d="M3.01996 21.75C2.82996 21.75 2.63996 21.68 2.48996 21.53C2.19996 21.24 2.19996 20.76 2.48996 20.47L20.47 2.48996C20.76 2.19996 21.24 2.19996 21.53 2.48996C21.82 2.77996 21.82 3.25996 21.53 3.54996L3.54996 21.53C3.40996 21.68 3.21996 21.75 3.01996 21.75Z"
      fill={fill || "#A8580F"}
    />
  </svg>
);

export const FeedbackIcon = ({ fill }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z"
      fill={fill || "#7B7F91"}
    />
    <path
      d="M17 8.75H7C6.59 8.75 6.25 9.09 6.25 9.5C6.25 9.91 6.59 10.25 7 10.25H17C17.41 10.25 17.75 9.91 17.75 9.5C17.75 9.09 17.41 8.75 17 8.75Z"
      fill={fill || "#7B7F91"}
    />
    <path
      d="M14 13.75H7C6.59 13.75 6.25 14.09 6.25 14.5C6.25 14.91 6.59 15.25 7 15.25H14C14.41 15.25 14.75 14.91 14.75 14.5C14.75 14.09 14.41 13.75 14 13.75Z"
      fill={fill || "#7B7F91"}
    />
  </svg>
);

export const ThumbsUpLike = ({ fill }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M21.6499 10.0307C21.2599 9.47071 20.5699 9.15071 19.7799 9.15071H15.6799C15.4099 9.15071 15.1599 9.04071 14.9899 8.84071C14.8099 8.64071 14.7399 8.36071 14.7799 8.07071L15.2899 4.79071C15.5099 3.81071 14.8599 2.71071 13.8799 2.38071C12.9699 2.04071 11.8999 2.50071 11.4699 3.15071L7.24988 9.42071C7.17136 9.55158 7.12988 9.70133 7.12988 9.85395V18.2486C7.12988 18.3844 7.18384 18.5147 7.27988 18.6107L10.4499 21.0607C10.8699 21.4807 11.8199 21.7107 12.4899 21.7107H16.3899C17.7299 21.7107 19.0799 20.7007 19.3799 19.4707L21.8399 11.9807C22.0999 11.2707 22.0299 10.5807 21.6499 10.0307Z"
      fill="#A8580F"
    />
    <path
      d="M5.21 6.38086H4.18C2.63 6.38086 2 6.98086 2 8.46086V18.5209C2 20.0009 2.63 20.6009 4.18 20.6009H5.21C6.76 20.6009 7.39 20.0009 7.39 18.5209V8.46086C7.39 6.98086 6.76 6.38086 5.21 6.38086Z"
      fill="#A8580F"
    />
  </svg>
);

export const HeartLike = ({ status = false }) => {
  return (
    <>
      {status ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 8.6901C22 9.8801 21.81 10.9801 21.48 12.0001H2.52C2.19 10.9801 2 9.8801 2 8.6901C2 5.6001 4.49 3.1001 7.56 3.1001C9.37 3.1001 10.99 3.9801 12 5.3301C13.01 3.9801 14.63 3.1001 16.44 3.1001C19.51 3.1001 22 5.6001 22 8.6901Z"
            fill="url(#paint0_linear_2223_1830)"
          />
          <path
            d="M21.4795 12C19.8995 17 15.0295 19.99 12.6195 20.81C12.2795 20.93 11.7195 20.93 11.3795 20.81C8.96953 19.99 4.09953 17 2.51953 12H21.4795Z"
            fill="url(#paint1_linear_2223_1830)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2223_1830"
              x1="22"
              y1="3.1001"
              x2="1.56025"
              y2="4.26162"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF483C" />
              <stop offset="1" stop-color="#FF2C5A" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2223_1830"
              x1="21.4795"
              y1="12"
              x2="2.09633"
              y2="13.0442"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF483C" />
              <stop offset="1" stop-color="#FF2C5A" />
            </linearGradient>
          </defs>
        </svg>
      ) : (
        <svg
          width="22"
          height="20"
          viewBox="0 0 22 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 19.6496C10.69 19.6496 10.39 19.6096 10.14 19.5196C6.32 18.2096 0.25 13.5596 0.25 6.68961C0.25 3.18961 3.08 0.349609 6.56 0.349609C8.25 0.349609 9.83 1.00961 11 2.18961C12.17 1.00961 13.75 0.349609 15.44 0.349609C18.92 0.349609 21.75 3.19961 21.75 6.68961C21.75 13.5696 15.68 18.2096 11.86 19.5196C11.61 19.6096 11.31 19.6496 11 19.6496ZM6.56 1.84961C3.91 1.84961 1.75 4.01961 1.75 6.68961C1.75 13.5196 8.32 17.3196 10.63 18.1096C10.81 18.1696 11.2 18.1696 11.38 18.1096C13.68 17.3196 20.26 13.5296 20.26 6.68961C20.26 4.01961 18.1 1.84961 15.45 1.84961C13.93 1.84961 12.52 2.55961 11.61 3.78961C11.33 4.16961 10.69 4.16961 10.41 3.78961C9.48 2.54961 8.08 1.84961 6.56 1.84961Z"
            fill={"#7B7F91"}
          />
        </svg>
      )}
    </>
  );
};

export const LikeStar = ({ status = false }) => {
  return (
    <>
      {status ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.2902 2.14096L15.2202 5.93095C15.2102 6.45095 15.5403 7.14096 15.9603 7.45096L18.4403 9.33096C20.0303 10.531 19.7703 12.001 17.8703 12.601L14.6403 13.611C14.1003 13.781 13.5303 14.371 13.3903 14.921L12.6203 17.861C12.0103 20.181 10.4902 20.411 9.23025 18.371L7.47024 15.521C7.15024 15.001 6.39024 14.611 5.79024 14.641L2.45028 14.811C0.0602772 14.931 -0.619732 13.551 0.940268 11.731L2.92025 9.43095C3.29025 9.00095 3.46024 8.20096 3.29024 7.66096L2.28029 4.43095C1.69029 2.53095 2.75028 1.48097 4.64028 2.10097L7.59029 3.07097C8.09029 3.23097 8.84027 3.12096 9.26027 2.81096L12.3403 0.590956C14.0003 -0.609044 15.3302 0.0909591 15.2902 2.14096Z"
            fill="#FFB800"
          />
        </svg>
      ) : (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0103 21.5005C11.4103 21.5005 10.4803 21.2105 9.59028 19.7505L7.83027 16.9005C7.66027 16.6205 7.14026 16.3505 6.82026 16.3705L3.48024 16.5405C1.48024 16.6405 0.780284 15.8105 0.530284 15.3105C0.280284 14.8105 0.0602404 13.7405 1.36024 12.2205L3.34028 9.92053C3.54028 9.68053 3.65025 9.1605 3.56025 8.8605L2.55024 5.63052C2.04024 4.01052 2.61025 3.14053 2.99025 2.76053C3.37024 2.38053 4.25025 1.83051 5.87025 2.37051L8.82026 3.34052C9.09026 3.43052 9.59026 3.35052 9.82026 3.19052L12.9003 0.97052C14.3103 -0.0494796 15.3302 0.22052 15.8002 0.47052C16.2702 0.72052 17.0702 1.40053 17.0402 3.14053L16.9702 6.93051C16.9602 7.21051 17.1902 7.67052 17.4102 7.84052L19.8903 9.72052C21.2403 10.7505 21.2903 11.7805 21.2003 12.3105C21.1103 12.8405 20.7103 13.8005 19.0903 14.3005L15.8602 15.3105C15.5602 15.4005 15.1902 15.7905 15.1102 16.0905L14.3403 19.0305C13.8303 20.9605 12.8303 21.3905 12.2703 21.4705C12.2003 21.4905 12.1103 21.5005 12.0103 21.5005ZM6.85023 14.8705C7.71023 14.8705 8.66023 15.3905 9.10023 16.1105L10.8602 18.9605C11.3602 19.7805 11.8102 20.0305 12.0502 19.9905C12.2802 19.9605 12.6403 19.5805 12.8903 18.6605L13.6602 15.7205C13.8702 14.9205 14.6202 14.1305 15.4102 13.8905L18.6403 12.8805C19.2603 12.6905 19.6602 12.3805 19.7202 12.0605C19.7802 11.7405 19.5002 11.3205 18.9802 10.9205L16.5003 9.04053C15.8903 8.58053 15.4503 7.66051 15.4603 6.90051L15.5303 3.1105C15.5403 2.4405 15.3803 1.94053 15.0903 1.79053C14.8003 1.64053 14.3103 1.79051 13.7603 2.18051L10.6802 4.40051C10.0702 4.84051 9.06027 5.00053 8.33027 4.76053L5.38026 3.79053C4.76026 3.59053 4.26028 3.60051 4.03028 3.83051C3.80028 4.06051 3.78023 4.56051 3.97023 5.18051L4.98024 8.41052C5.23024 9.20052 5.01023 10.2705 4.47023 10.8905L2.49025 13.1905C1.86025 13.9205 1.76025 14.4305 1.87025 14.6405C1.97025 14.8505 2.45028 15.0805 3.40028 15.0305L6.74025 14.8605C6.78025 14.8705 6.82023 14.8705 6.85023 14.8705Z"
            fill="#7B7F91"
          />
        </svg>
      )}
    </>
  );
};

export const CommentIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M22 6.25V11.35C22 12.62 21.58 13.69 20.83 14.43C20.09 15.18 19.02 15.6 17.75 15.6V17.41C17.75 18.09 16.99 18.5 16.43 18.12L15.46 17.48C15.55 17.17 15.59 16.83 15.59 16.47V12.4C15.59 10.36 14.23 9 12.19 9H5.39999C5.25999 9 5.13 9.01002 5 9.02002V6.25C5 3.7 6.7 2 9.25 2H17.75C20.3 2 22 3.7 22 6.25Z"
      fill="#A8580F"
    />
    <path
      d="M15.59 12.4V16.47C15.59 16.83 15.55 17.17 15.46 17.48C15.09 18.95 13.87 19.87 12.19 19.87H9.47L6.45 21.88C6 22.19 5.39999 21.86 5.39999 21.32V19.87C4.37999 19.87 3.53 19.53 2.94 18.94C2.34 18.34 2 17.49 2 16.47V12.4C2 10.5 3.18 9.19002 5 9.02002C5.13 9.01002 5.25999 9 5.39999 9H12.19C14.23 9 15.59 10.36 15.59 12.4Z"
      fill="#A8580F"
    />
  </svg>
);

export const ThumbsUpUnLike = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2804 22.1005H12.4804C11.9204 22.1005 10.7004 21.9305 10.0504 21.2805L7.02035 18.9405L7.94035 17.7505L11.0404 20.1505C11.2904 20.3905 11.9204 20.5905 12.4804 20.5905H16.2804C17.1804 20.5905 18.1504 19.8705 18.3504 19.0605L20.7704 11.7105C20.9304 11.2705 20.9004 10.8705 20.6904 10.5805C20.4704 10.2705 20.0704 10.0905 19.5804 10.0905H15.5804C15.0604 10.0905 14.5804 9.87048 14.2504 9.49048C13.9104 9.10048 13.7604 8.58048 13.8404 8.04048L14.3404 4.83048C14.4604 4.27048 14.0804 3.64048 13.5404 3.46048C13.0504 3.28048 12.4204 3.54048 12.2004 3.86048L8.10035 9.96048L6.86035 9.13048L10.9604 3.03048C11.5904 2.09048 12.9704 1.64048 14.0504 2.05048C15.3004 2.46048 16.1004 3.84048 15.8204 5.12048L15.3304 8.27048C15.3204 8.34048 15.3204 8.44048 15.3904 8.52048C15.4404 8.57048 15.5104 8.60048 15.5904 8.60048H19.5904C20.5704 8.60048 21.4204 9.01048 21.9204 9.72048C22.4104 10.4105 22.5104 11.3205 22.1904 12.2005L19.8004 19.4805C19.4304 20.9305 17.8904 22.1005 16.2804 22.1005Z"
      fill="#7B7F91"
    />
    <path
      d="M5.37988 21.0004H4.37988C2.52988 21.0004 1.62988 20.1304 1.62988 18.3504V8.55039C1.62988 6.77039 2.52988 5.90039 4.37988 5.90039H5.37988C7.22988 5.90039 8.12988 6.77039 8.12988 8.55039V18.3504C8.12988 20.1304 7.22988 21.0004 5.37988 21.0004ZM4.37988 7.40039C3.28988 7.40039 3.12988 7.66039 3.12988 8.55039V18.3504C3.12988 19.2404 3.28988 19.5004 4.37988 19.5004H5.37988C6.46988 19.5004 6.62988 19.2404 6.62988 18.3504V8.55039C6.62988 7.66039 6.46988 7.40039 5.37988 7.40039H4.37988Z"
      fill="#7B7F91"
    />
  </svg>
);

export const UploadImage = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M27.5 9.7625V17.375L25.4625 15.625C24.4875 14.7875 22.9125 14.7875 21.9375 15.625L16.7375 20.0875C15.7625 20.925 14.1875 20.925 13.2125 20.0875L12.7875 19.7375C11.9 18.9625 10.4875 18.8875 9.4875 19.5625L3.3375 23.6875L3.2 23.7875C2.7375 22.7875 2.5 21.6 2.5 20.2375V9.7625C2.5 5.2125 5.2125 2.5 9.7625 2.5H20.2375C24.7875 2.5 27.5 5.2125 27.5 9.7625Z"
        fill="#A8580F"
      />
      <path
        d="M11.2504 12.9754C12.8934 12.9754 14.2254 11.6434 14.2254 10.0004C14.2254 8.35734 12.8934 7.02539 11.2504 7.02539C9.60734 7.02539 8.27539 8.35734 8.27539 10.0004C8.27539 11.6434 9.60734 12.9754 11.2504 12.9754Z"
        fill="#A8580F"
      />
      <path
        d="M27.5002 17.3742V20.2367C27.5002 24.7867 24.7877 27.4992 20.2377 27.4992H9.7627C6.5752 27.4992 4.2752 26.1617 3.2002 23.7867L3.3377 23.6867L9.4877 19.5617C10.4877 18.8867 11.9002 18.9617 12.7877 19.7367L13.2127 20.0867C14.1877 20.9242 15.7627 20.9242 16.7377 20.0867L21.9377 15.6242C22.9127 14.7867 24.4877 14.7867 25.4627 15.6242L27.5002 17.3742Z"
        fill="#A8580F"
      />
    </svg>
  );
};
export const SuspendedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M21.0902 21.5C21.0902 21.78 20.8702 22 20.5902 22H3.41016C3.13016 22 2.91016 21.78 2.91016 21.5C2.91016 17.36 6.99018 14 12.0002 14C13.0302 14 14.0302 14.14 14.9502 14.41C14.3602 15.11 14.0002 16.02 14.0002 17C14.0002 17.75 14.2102 18.46 14.5802 19.06C14.7802 19.4 15.0402 19.71 15.3402 19.97C16.0402 20.61 16.9702 21 18.0002 21C19.1202 21 20.1302 20.54 20.8502 19.8C21.0102 20.34 21.0902 20.91 21.0902 21.5Z"
        fill="#7B7F91"
      />
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        fill="#7B7F91"
      />
      <path
        d="M20.97 14.83C20.25 14.01 19.18 13.5 18 13.5C15.79 13.5 14 15.29 14 17.5C14 18.25 14.21 18.96 14.58 19.56C14.78 19.9 15.04 20.21 15.34 20.47C16.04 21.11 16.97 21.5 18 21.5C19.46 21.5 20.73 20.72 21.42 19.56C21.79 18.96 22 18.25 22 17.5C22 16.48 21.61 15.54 20.97 14.83ZM19.6 19.08C19.45 19.23 19.26 19.3 19.07 19.3C18.88 19.3 18.69 19.23 18.54 19.08L18.01 18.55L17.46 19.1C17.31 19.25 17.12 19.32 16.93 19.32C16.74 19.32 16.55 19.25 16.4 19.1C16.11 18.81 16.11 18.33 16.4 18.04L16.95 17.49L16.42 16.96C16.13 16.67 16.13 16.19 16.42 15.9C16.71 15.61 17.19 15.61 17.48 15.9L18.01 16.43L18.51 15.93C18.8 15.64 19.28 15.64 19.57 15.93C19.86 16.22 19.86 16.7 19.57 16.99L19.07 17.49L19.6 18.02C19.89 18.31 19.89 18.78 19.6 19.08Z"
        fill="#7B7F91"
      />
    </svg>
  );
};

export const PostIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z"
        fill="#7B7F91"
      />
      <path
        d="M16.5514 7.46019C15.2914 6.20019 14.0714 6.17019 12.7814 7.46019L11.9914 8.25019C11.9214 8.32019 11.9014 8.42019 11.9214 8.51019C12.4114 10.2302 13.7814 11.6002 15.5014 12.0902C15.5214 12.1002 15.5514 12.1002 15.5814 12.1002C15.6514 12.1002 15.7214 12.0702 15.7714 12.0202L16.5514 11.2402C17.1914 10.6002 17.5014 9.99019 17.5014 9.37019C17.5014 8.72019 17.1914 8.10019 16.5514 7.46019Z"
        fill="#7B7F91"
      />
      <path
        d="M14.3404 12.6711C14.1504 12.5811 13.9704 12.4911 13.8004 12.3811C13.6604 12.3011 13.5204 12.2111 13.3904 12.1111C13.2804 12.0411 13.1504 11.9411 13.0204 11.8311C13.0004 11.8211 12.9604 11.7911 12.9104 11.7311C12.7004 11.5511 12.4604 11.3111 12.2404 11.0611C12.2204 11.0511 12.1904 11.0011 12.1504 10.9411C12.0804 10.8611 11.9804 10.7311 11.8804 10.5911C11.8004 10.4911 11.7104 10.3511 11.6304 10.2111C11.5304 10.0411 11.4304 9.86109 11.3504 9.68109C11.2604 9.48109 11.1904 9.30109 11.1204 9.12109L7.35044 12.8911C7.10044 13.1411 6.87044 13.6011 6.82044 13.9411L6.53043 16.0211C6.46043 16.4611 6.59042 16.8711 6.86042 17.1511C7.09042 17.3811 7.41044 17.5011 7.76044 17.5011C7.84044 17.5011 7.91042 17.4911 7.99042 17.4811L10.0704 17.1911C10.4104 17.1411 10.8704 16.9111 11.1204 16.6611L14.8904 12.8911C14.7104 12.8211 14.5304 12.7511 14.3404 12.6711Z"
        fill="#7B7F91"
      />
    </svg>
  );
};

export const BlockedUserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M21.0902 21.5C21.0902 21.78 20.8702 22 20.5902 22H3.41016C3.13016 22 2.91016 21.78 2.91016 21.5C2.91016 17.36 6.99018 14 12.0002 14C13.0302 14 14.0302 14.14 14.9502 14.41C14.3602 15.11 14.0002 16.02 14.0002 17C14.0002 17.75 14.2102 18.46 14.5802 19.06C14.7802 19.4 15.0402 19.71 15.3402 19.97C16.0402 20.61 16.9702 21 18.0002 21C19.1202 21 20.1302 20.54 20.8502 19.8C21.0102 20.34 21.0902 20.91 21.0902 21.5Z"
        fill="#7B7F91"
      />
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        fill="#7B7F91"
      />
      <path
        d="M20.3233 14.6473C19.0402 13.3642 16.9598 13.3642 15.6767 14.6473C14.3936 15.9304 14.3936 18.0108 15.6767 19.2939C16.9598 20.577 19.0402 20.577 20.3233 19.2939C21.6064 18.0108 21.6064 15.9304 20.3233 14.6473Z"
        fill="#CACCD3"
        stroke="#7B7F91"
        strokeWidth="0.5"
      />
      <path
        d="M19.8177 14.6745L15.6647 18.8275C15.4519 19.0403 15.3839 19.3253 15.5147 19.4561C15.6454 19.5869 15.9304 19.5188 16.1432 19.306L20.2962 15.153C20.5091 14.9402 20.5771 14.6552 20.4463 14.5244C20.3155 14.3936 20.0357 14.4565 19.8177 14.6745Z"
        fill="#7B7F91"
      />
    </svg>
  );
};

export const VisibleDataIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 16.3299C9.60992 16.3299 7.66992 14.3899 7.66992 11.9999C7.66992 9.60992 9.60992 7.66992 11.9999 7.66992C14.3899 7.66992 16.3299 9.60992 16.3299 11.9999C16.3299 14.3899 14.3899 16.3299 11.9999 16.3299ZM11.9999 9.16992C10.4399 9.16992 9.16992 10.4399 9.16992 11.9999C9.16992 13.5599 10.4399 14.8299 11.9999 14.8299C13.5599 14.8299 14.8299 13.5599 14.8299 11.9999C14.8299 10.4399 13.5599 9.16992 11.9999 9.16992Z"
        fill="#292D32"
      />
      <path
        d="M12.0001 21.0205C8.24008 21.0205 4.69008 18.8205 2.25008 15.0005C1.19008 13.3505 1.19008 10.6605 2.25008 9.00047C4.70008 5.18047 8.25008 2.98047 12.0001 2.98047C15.7501 2.98047 19.3001 5.18047 21.7401 9.00047C22.8001 10.6505 22.8001 13.3405 21.7401 15.0005C19.3001 18.8205 15.7501 21.0205 12.0001 21.0205ZM12.0001 4.48047C8.77008 4.48047 5.68008 6.42047 3.52008 9.81047C2.77008 10.9805 2.77008 13.0205 3.52008 14.1905C5.68008 17.5805 8.77008 19.5205 12.0001 19.5205C15.2301 19.5205 18.3201 17.5805 20.4801 14.1905C21.2301 13.0205 21.2301 10.9805 20.4801 9.81047C18.3201 6.42047 15.2301 4.48047 12.0001 4.48047Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const HideDataIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M21.2496 9.14906C20.7596 8.36906 20.1996 7.66906 19.6196 7.03906L15.8496 10.8091C15.9696 11.1791 16.0396 11.5791 16.0396 11.9991C16.0396 14.2391 14.2296 16.0391 11.9996 16.0391C11.5796 16.0391 11.1796 15.9691 10.8096 15.8491L7.34961 19.3091C8.80961 20.1291 10.3896 20.5591 11.9996 20.5591C13.7796 20.5591 15.5096 20.0391 17.0896 19.0691C18.6696 18.0891 20.0896 16.6591 21.2496 14.8391C22.2496 13.2791 22.2496 10.7191 21.2496 9.14906Z"
        fill="#242424"
      />
      <path
        d="M14.0206 9.98062L9.98062 14.0206C9.47062 13.5006 9.14062 12.7806 9.14062 12.0006C9.14062 10.4306 10.4206 9.14062 12.0006 9.14062C12.7806 9.14062 13.5006 9.47062 14.0206 9.98062Z"
        fill="#242424"
      />
      <path
        opacity="0.4"
        d="M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z"
        fill="#242424"
      />
      <path
        d="M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z"
        fill="#242424"
      />
      <path
        d="M21.7709 2.23086C21.4709 1.93086 20.9809 1.93086 20.6809 2.23086L2.23086 20.6909C1.93086 20.9909 1.93086 21.4809 2.23086 21.7809C2.38086 21.9209 2.57086 22.0009 2.77086 22.0009C2.97086 22.0009 3.16086 21.9209 3.31086 21.7709L21.7709 3.31086C22.0809 3.01086 22.0809 2.53086 21.7709 2.23086Z"
        fill="#242424"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        fill="#292D32"
      />
      <path
        d="M17 8.25H7C6.59 8.25 6.25 7.91 6.25 7.5C6.25 7.09 6.59 6.75 7 6.75H17C17.41 6.75 17.75 7.09 17.75 7.5C17.75 7.91 17.41 8.25 17 8.25Z"
        fill="#292D32"
      />
      <path
        d="M17 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H17C17.41 11.25 17.75 11.59 17.75 12C17.75 12.41 17.41 12.75 17 12.75Z"
        fill="#292D32"
      />
      <path
        d="M17 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H17C17.41 15.75 17.75 16.09 17.75 16.5C17.75 16.91 17.41 17.25 17 17.25Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const EditBorderIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07881 17.8926C4.51964 17.8926 3.99714 17.7001 3.62131 17.3426C3.14464 16.8934 2.91548 16.2151 2.99798 15.4818L3.33714 12.5118C3.40131 11.9526 3.74048 11.2101 4.13464 10.8068L11.6605 2.84094C13.5396 0.851772 15.5013 0.796772 17.4905 2.67594C19.4796 4.55511 19.5346 6.51677 17.6555 8.50594L10.1296 16.4718C9.74464 16.8843 9.02964 17.2693 8.47048 17.3609L5.51881 17.8651C5.36298 17.8743 5.22548 17.8926 5.07881 17.8926ZM14.603 2.66677C13.8971 2.66677 13.283 3.10677 12.6596 3.76677L5.13381 11.7418C4.95048 11.9343 4.73964 12.3926 4.70298 12.6584L4.36381 15.6284C4.32714 15.9309 4.40048 16.1784 4.56548 16.3343C4.73048 16.4901 4.97798 16.5451 5.28048 16.4993L8.23214 15.9951C8.49798 15.9493 8.93798 15.7109 9.12131 15.5184L16.6471 7.55261C17.7838 6.34261 18.1963 5.22427 16.5371 3.66594C15.8038 2.96011 15.1713 2.66677 14.603 2.66677Z"
        fill="#7B7F91"
      />
      <path
        d="M15.8951 10.0374C15.8767 10.0374 15.8492 10.0374 15.8309 10.0374C12.9709 9.75328 10.6701 7.58078 10.2301 4.73911C10.1751 4.36328 10.4317 4.01494 10.8076 3.95078C11.1834 3.89578 11.5317 4.15244 11.5959 4.52828C11.9442 6.74661 13.7409 8.45161 15.9776 8.67161C16.3534 8.70828 16.6284 9.04744 16.5917 9.42328C16.5459 9.77161 16.2434 10.0374 15.8951 10.0374Z"
        fill="#7B7F91"
      />
      <path
        d="M19.25 20.8535H2.75C2.37417 20.8535 2.0625 20.5418 2.0625 20.166C2.0625 19.7902 2.37417 19.4785 2.75 19.4785H19.25C19.6258 19.4785 19.9375 19.7902 19.9375 20.166C19.9375 20.5418 19.6258 20.8535 19.25 20.8535Z"
        fill="#7B7F91"
      />
    </svg>
  );
};

export const ProfileUploadIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#FD38AE" />
      <path
        opacity="0.4"
        d="M8.94408 17.8346H15.0574C16.6674 17.8346 17.3091 16.8488 17.3849 15.6471L17.6882 10.8288C17.7699 9.5688 16.7666 8.5013 15.5007 8.5013C15.1449 8.5013 14.8182 8.29714 14.6549 7.98214L14.2349 7.1363C13.9666 6.60547 13.2666 6.16797 12.6716 6.16797H11.3357C10.7349 6.16797 10.0349 6.60547 9.76658 7.1363L9.34658 7.98214C9.18325 8.29714 8.85658 8.5013 8.50075 8.5013C7.23492 8.5013 6.23158 9.5688 6.31325 10.8288L6.61658 15.6471C6.68658 16.8488 7.33408 17.8346 8.94408 17.8346Z"
        fill="white"
      />
      <path
        d="M12.875 10.1055H11.125C10.8858 10.1055 10.6875 9.90714 10.6875 9.66797C10.6875 9.4288 10.8858 9.23047 11.125 9.23047H12.875C13.1142 9.23047 13.3125 9.4288 13.3125 9.66797C13.3125 9.90714 13.1142 10.1055 12.875 10.1055Z"
        fill="white"
      />
      <path
        d="M12.001 15.5761C13.0899 15.5761 13.9726 14.6934 13.9726 13.6045C13.9726 12.5156 13.0899 11.6328 12.001 11.6328C10.912 11.6328 10.0293 12.5156 10.0293 13.6045C10.0293 14.6934 10.912 15.5761 12.001 15.5761Z"
        fill="white"
      />
    </svg>
  );
};

export const CopyContentIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.47533 13.2702H4.02533C1.74449 13.2702 0.729492 12.2552 0.729492 9.97435V7.52435C0.729492 5.24352 1.74449 4.22852 4.02533 4.22852H6.47533C8.75616 4.22852 9.77116 5.24352 9.77116 7.52435V9.97435C9.77116 12.2552 8.75616 13.2702 6.47533 13.2702ZM4.02533 5.10352C2.21699 5.10352 1.60449 5.71602 1.60449 7.52435V9.97435C1.60449 11.7827 2.21699 12.3952 4.02533 12.3952H6.47533C8.28366 12.3952 8.89616 11.7827 8.89616 9.97435V7.52435C8.89616 5.71602 8.28366 5.10352 6.47533 5.10352H4.02533Z"
        fill="#7B7F91"
      />
      <path
        d="M9.97533 9.77018H9.33366C9.09449 9.77018 8.89616 9.57185 8.89616 9.33268V7.52435C8.89616 5.71602 8.28366 5.10352 6.47533 5.10352H4.66699C4.42783 5.10352 4.22949 4.90518 4.22949 4.66602V4.02435C4.22949 1.74352 5.24449 0.728516 7.52533 0.728516H9.97533C12.2562 0.728516 13.2712 1.74352 13.2712 4.02435V6.47435C13.2712 8.75518 12.2562 9.77018 9.97533 9.77018ZM9.77116 8.89518H9.97533C11.7837 8.89518 12.3962 8.28268 12.3962 6.47435V4.02435C12.3962 2.21602 11.7837 1.60352 9.97533 1.60352H7.52533C5.71699 1.60352 5.10449 2.21602 5.10449 4.02435V4.22852H6.47533C8.75616 4.22852 9.77116 5.24352 9.77116 7.52435V8.89518Z"
        fill="#7B7F91"
      />
    </svg>
  );
};

export const ProfileIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59488 10.7108C9.57905 10.7108 9.5553 10.7108 9.53947 10.7108C9.51572 10.7108 9.48405 10.7108 9.4603 10.7108C7.66322 10.6554 6.31738 9.25414 6.31738 7.52831C6.31738 5.77081 7.7503 4.33789 9.5078 4.33789C11.2653 4.33789 12.6982 5.77081 12.6982 7.52831C12.6903 9.26206 11.3365 10.6554 9.61863 10.7108C9.6028 10.7108 9.6028 10.7108 9.59488 10.7108ZM9.49988 5.51747C8.39155 5.51747 7.49697 6.41997 7.49697 7.52039C7.49697 8.60497 8.34405 9.48372 9.42072 9.52331C9.44447 9.51539 9.52363 9.51539 9.6028 9.52331C10.6636 9.46789 11.4949 8.59706 11.5028 7.52039C11.5028 6.41997 10.6082 5.51747 9.49988 5.51747Z"
        fill="#292D32"
      />
      <path
        d="M9.50032 18.0097C7.37073 18.0097 5.33615 17.218 3.76073 15.7772C3.61823 15.6505 3.5549 15.4605 3.57073 15.2784C3.67365 14.3364 4.25948 13.4576 5.23323 12.8084C7.5924 11.2409 11.4162 11.2409 13.7674 12.8084C14.7412 13.4655 15.327 14.3364 15.4299 15.2784C15.4537 15.4684 15.3824 15.6505 15.2399 15.7772C13.6645 17.218 11.6299 18.0097 9.50032 18.0097ZM4.81365 15.1201C6.12782 16.2205 7.7824 16.8222 9.50032 16.8222C11.2182 16.8222 12.8728 16.2205 14.187 15.1201C14.0445 14.6372 13.6645 14.1701 13.1024 13.7901C11.1549 12.4918 7.85365 12.4918 5.89032 13.7901C5.32823 14.1701 4.95615 14.6372 4.81365 15.1201Z"
        fill="#292D32"
      />
      <path
        d="M9.49967 18.0111C4.80509 18.0111 0.989258 14.1952 0.989258 9.50065C0.989258 4.80607 4.80509 0.990234 9.49967 0.990234C14.1943 0.990234 18.0101 4.80607 18.0101 9.50065C18.0101 14.1952 14.1943 18.0111 9.49967 18.0111ZM9.49967 2.17773C5.46217 2.17773 2.17676 5.46315 2.17676 9.50065C2.17676 13.5382 5.46217 16.8236 9.49967 16.8236C13.5372 16.8236 16.8226 13.5382 16.8226 9.50065C16.8226 5.46315 13.5372 2.17773 9.49967 2.17773Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const TestimonialIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M17 18.4297H13L8.54999 21.3897C7.88999 21.8297 7 21.3597 7 20.5597V18.4297C4 18.4297 2 16.4297 2 13.4297V7.42969C2 4.42969 4 2.42969 7 2.42969H17C20 2.42969 22 4.42969 22 7.42969V13.4297C22 16.4297 20 18.4297 17 18.4297Z"
        fill="#7B7F91"
      />
      <path
        d="M12.6909 6.57768L13.3968 7.99734C13.492 8.19368 13.7473 8.37995 13.9626 8.42022L15.2393 8.63166C16.0553 8.76758 16.2456 9.36163 15.6598 9.95567L14.6635 10.9575C14.4983 11.1236 14.4032 11.4508 14.4582 11.6875L14.7436 12.9259C14.9689 13.9025 14.4482 14.2851 13.5921 13.7716L12.3955 13.0568C12.1802 12.9259 11.8198 12.9259 11.6045 13.0568L10.4079 13.7716C9.55176 14.2801 9.03108 13.9025 9.25638 12.9259L9.54176 11.6875C9.59683 11.4559 9.5017 11.1287 9.33648 10.9575L8.34018 9.95567C7.7544 9.36666 7.94465 8.77262 8.76073 8.63166L10.0374 8.42022C10.2527 8.38498 10.508 8.19368 10.6032 7.99734L11.3091 6.57768C11.6846 5.80744 12.3054 5.80744 12.6909 6.57768Z"
        fill="#7B7F91"
      />
    </svg>
  );
};